/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
/* eslint-disable no-new-func */
import React, {
  useEffect,
  useState,
  useMemo,
  useRef,
  useCallback,
} from "react";
import { createPortal } from "react-dom";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import SystemUpdateAltIcon from "@mui/icons-material/SystemUpdateAlt";
import TravelExploreIcon from "@mui/icons-material/TravelExplore";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import VisibilityIcon from "@mui/icons-material/Visibility";
import axios from "axios";
import ClipLoader from "react-spinners/ClipLoader";
import "../All CSS/FormMaster.css";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import moment from "moment";
import { MdDeleteOutline } from "react-icons/md";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import SearchIcon from "@mui/icons-material/Search";
import { useTheme, useMediaQuery } from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAuth } from "../Components/StoredDetails";
import BasePopup from "../Components/BasePopup";

const API = process.env.REACT_APP_API_BASE_URL;

const colorMap = {
  "Color.White": "#ffffff",
  "Color.PeachPuff": "#FFDAB9",
  "Color.LemonChiffon": "#FFFACD",
  "Color.PaleGreen": "#98FB98",
  "Color.LightGray": "#f1f5f9",
  "Color.Gray": "#F1F5F9",
};

const getStatusStyle = {
  DRAFT: "linear-gradient(135deg,#2563eb,#60a5fa)",
  APPROVED: "linear-gradient(135deg,#16a34a,#4ade80)",
  REJECTED: "linear-gradient(135deg,#dc2626,#f87171)",
  RELEASED: "linear-gradient(135deg,#db2777,#f472b6)",
};

const resolveColor = (dbColor) =>
  colorMap[dbColor] || dbColor || "var(--input-bg)";

const isFieldVisible = (value) => {
  if (value === null || value === undefined || value === "") return true;

  const normalized = String(value).trim().toLowerCase();
  return !["n", "no", "false", "0", "hide", "hidden"].includes(normalized);
};

const emptyRow = () => ({
  _rowId: Date.now() + Math.random(),
  isExisting: false,
  file: null,
  filePath: "",
  fileName: "",
  fileExt: "",
  fileData: "",
  attachmentDate: dayjs().format("DD-MM-YYYY"),
  remarks: "",
  docType: "",
});

const formatDate = (date) => {
  if (!date) return "";
  return dayjs(date).format("DD-MM-YYYY");
};

const DateField = ({
  label,
  name,
  value = "",
  onChange,
  size = "full",
  disabled = false,
  width = "200px",
  required = false
}) => {

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // 👇 Responsive width
  const responsiveWidth = isMobile ? "142px" : width;

  const dateValue = value
    ? dayjs(value, "DD-MM-YYYY")
    : dayjs();

  const filled = !!value;

  return (
    <div
      className={`float-field ${size} ${disabled ? "disabled" : ""}`}
      style={{ width: responsiveWidth }}
    >
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          value={dateValue}
          format="DD-MM-YYYY"
          disabled={disabled}
          onChange={(newValue) => {
            if (!newValue) {
              onChange({ target: { name, value: "" } });
              return;
            }

            onChange({
              target: {
                name,
                value: newValue.format("DD-MM-YYYY")
              }
            });
          }}
          PopperProps={{ sx: { zIndex: 14000 } }}
          slotProps={{
            popper: {
              className: "purchase-order-date-picker-popper"
            },
            desktopPaper: {
              className: "purchase-order-date-picker-paper"
            },
            mobilePaper: {
              className: "purchase-order-date-picker-paper"
            },
            textField: {
              className: "purchase-order-date-control",
              sx: {
                width: "100%",
              },
              InputProps: {
                disableUnderline: true,
                style: {
                  height: "36px",
                  fontSize: "14px",
                  color: "var(--text-primary)"
                }
              }
            }
          }}
        />
      </LocalizationProvider>

      <label className={`date-field-label ${filled ? "filled" : ""}`}>{label}
        {required && <span className="required-star"> *</span>}
      </label>
    </div>
  );
};

function FrmAPInvoice_MBC({ autoLoad = false, purchaseOrderHeaderTarget = null }) {
  const { authData } = useAuth();
  const userDetails = authData?.user;
  const UserLocation = authData?.selectedLocation;
  const UserID = userDetails?.UserID;

  const CompanyCode = UserLocation.CompCode;
  const CompanyName = UserLocation.CompName;
  const CompanyLocation = UserLocation.CompLocation;

  const [loading, setLoading] = useState(true);
  const [cfg, setCfg] = useState([]);
  const [allCfg, setAllCfg] = useState([]);
  const [data, setData] = useState({});

  const [gridCfg, setGridCfg] = useState([]);
  const [gridTabs, setGridTabs] = useState([]);
  const [gridConfigMap, setGridConfigMap] = useState({});
  const [allGridConfigMap, setAllGridConfigMap] = useState({});
  const [gridRowsMap, setGridRowsMap] = useState({});
  const [rowData, setRowData] = useState([]);

  const [gridComboCache, setGridComboCache] = useState({});
  const [gridCalc, setGridCalc] = useState([]);
  

  const [attachmentGridCfg, setAttachmentGridCfg] = useState([]);
  const [attachmentData, setAttachmentData] = useState([]);
  const [docTypes, setDocTypes] = useState([]);
  const [gridColumnWidths, setGridColumnWidths] = useState({});
  const fileInputRefs = useRef([]);
  const resizeStateRef = useRef({ field: null, startX: 0, startWidth: 0 });
  const previousGridTabRef = useRef("");
  const [activeGridTab, setActiveGridTab] = useState("");

  const [pageMode, setPageMode] = useState("FIND");
  // const isFindMode = pageMode === "FIND";
  const [findPopup, setFindPopup] = useState({
    open: false,
    data: [],
    loading: false,
  });
  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const [isApprovedView, setIsApprovedView] = useState(false);
  const [isCopyToOpen, setIsCopyToOpen] = useState(false);
  const copyToRef = useRef(null);
  const [form, setForm] = useState({
    findDisplay: "",
    findDocEntry: null,
  });

  const [findFilters, setFindFilters] = useState({
    docMode: "",
    docStatus: "",
    fromDate: "01-01-1900",
    toDate: formatDate(dayjs()),
    ignoreDate: true,
  });
  const [findResults, setFindResults] = useState([]);
  const [showFindTable, setShowFindTable] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [pageIndex, setPageIndex] = useState(0);
  const [findPageSize, setFindPageSize] = useState(10);

  const [popup, setPopup] = useState({
    open: false,
    label: "",
    value: "",
  });

  const [filePreview, setFilePreview] = useState({
    open: false,
    name: "",
    src: "",
    type: "",
  });

  const [selectPopup, setSelectPopup] = useState({
    open: false,
    field: null,
    columns: [],
    rows: [],
    search: "",
  });

  const [gridPopup, setGridPopup] = useState({
    open: false,
    rowIndex: null,
    field: null,
    columns: [],
    rows: [],
    search: "",
  });

  const [itemDetailsPopup, setItemDetailsPopup] = useState({
    open: false,
    gridKey: "",
    rowIndex: null,
    field: "",
    value: "",
    title: "Item Details",
  });

  const [linePopup, setLinePopup] = useState({
    open: false,
    rowIndex: null,
    row: {},
  });

  useEffect(() => {
    if (!isCopyToOpen) return undefined;

    const handleOutsideClick = (event) => {
      if (!copyToRef.current?.contains(event.target)) {
        setIsCopyToOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, [isCopyToOpen]);

  const padDocNum = (val, length = 4) => {
    if (val === null || val === undefined || val === "") return "";
    return String(val).padStart(length, "0");
  };

  const fetchNextDocNum = async (series, dueDate) => {
    if (!series) return;

    try {
      const res = await axios.post(`${API}/api/get-ap-invoice-control-value`, {
        fieldName: "DocNum",
        formData: {
          CompCode: CompanyCode,
          Location: CompanyLocation,
          CompLocation: CompanyLocation,
          UserID: UserID,
          VDate: dueDate,
          Series: series,
        },
      });

      if (
        res.data?.value !== undefined &&
        res.data?.value !== null &&
        res.data.value !== ""
      ) {
        setData((p) => ({
          ...p,
          DocNum: padDocNum(res.data.value),
        }));
      }
    } catch (err) {
      console.error("DocNum fetch error:", err);
    }
  };

  useEffect(() => {
    setLoading(true);

    fetch(`${API}/config/FrmAPInvoice_MBC-frms.json`)
      .then((res) => {
        if (!res.ok) throw new Error("AP Invoice JSON config not found");
        return res.json();
      })
      .then((rows) => {
        const allRows = Array.isArray(rows) ? rows : [];
        if (!allRows.length) throw new Error("AP Invoice JSON config is empty");
        const visibleRows = allRows.filter((r) => isFieldVisible(r.Visible));

        setAllCfg(allRows);
        setCfg(visibleRows);

        const d = {};
        allRows.forEach((r) => {
          if (!r.ColHdName) return;

          let value = "";

          if (r._QueryValue !== null && r._QueryValue !== undefined) {
            value = r._QueryValue;
          } else if (r.DefaultValue) {
            value = r.DefaultValue.replace(/[()']/g, "");
          }

          if (r.ColHdName === "CompCode") value = CompanyCode;
          if (r.ColHdName === "CompName") value = CompanyName;
          if (r.ColHdName === "Location") value = CompanyLocation;
          if (r.ColHdName === "DocStatus" && !value) value = "OPEN";

          if (r.ColType === "DatePicker") {
            value = moment().format("YYYY-MM-DD");
          }

          // ✅ IMPORTANT: DocNum stays blank initially
          if (r.ColHdName === "DocNum") {
            value = "";
          }

          d[r.ColHdName] = value;
        });
        setData(d);
      })
      .catch(async () => {
        const res = await axios.post(`${API}/api/get-form-design-APInvoice_MBC`, {
          formName: "FrmAPInvoice_MBC",
          formData: {
            CompCode: CompanyCode,
            Location: CompanyLocation,
            UserID: UserID,
          },
        });
        const allRows = Array.isArray(res.data) ? res.data : [];
        setAllCfg(allRows);
        setCfg(allRows.filter((r) => isFieldVisible(r.Visible)));
        const fallbackData = {};
        allRows.forEach((r) => {
          if (!r.ColHdName) return;
          let value = r.DefaultValue
            ? r.DefaultValue.replace(/[()']/g, "")
            : "";
          if (r.ColHdName === "CompCode") value = CompanyCode;
          if (r.ColHdName === "CompName") value = CompanyName;
          if (r.ColHdName === "Location") value = CompanyLocation;
          if (r.ColHdName === "DocStatus" && !value) value = "OPEN";
          if (r.ColType === "DatePicker") value = moment().format("YYYY-MM-DD");
          if (r.ColHdName === "DocNum") value = "";
          fallbackData[r.ColHdName] = value;
        });
        setData(fallbackData);
      })
      .catch((err) => console.error("Form load error:", err))
      .finally(() => setLoading(false));
  }, [CompanyCode, CompanyLocation, CompanyName, UserID]);

  useEffect(() => {
    if (isUpdateMode || !CompanyCode || !CompanyLocation) return;

    axios
      .post(`${API}/api/get-ap-invoice-control-value`, {
        fieldName: "Series",
        formData: {
          CompCode: CompanyCode,
          Location: CompanyLocation,
          CompLocation: CompanyLocation,
          UserID,
          VDate: dayjs().format("YYYY-MM-DD"),
        },
      })
      .then((res) => {
        const value = res.data?.value;
        const options = res.data?.options || [];
        if (value !== undefined && value !== null && value !== "") {
          setData((prev) => ({ ...prev, Series: value }));
        } else if (options.length === 1) {
          const option = options[0];
          const selectedSeries =
            option.Series ?? option.Code ?? Object.values(option)[0];
          if (
            selectedSeries !== undefined &&
            selectedSeries !== null &&
            selectedSeries !== ""
          ) {
            setData((prev) => ({ ...prev, Series: selectedSeries }));
          }
        }

        if (options.length) {
          const addOptions = (field) =>
            field.ColHdName === "Series"
              ? { ...field, _QueryTable: options }
              : field;
          setCfg((prev) => prev.map(addOptions));
          setAllCfg((prev) => prev.map(addOptions));
        }
      })
      .catch((err) => console.error("Series load error:", err));
  }, [CompanyCode, CompanyLocation, UserID, isUpdateMode]);

  useEffect(() => {
    if (isUpdateMode) return;
    if (!data.Series) return;
    fetchNextDocNum(data.Series, data.DueDate);
  }, [
    data.Series,
    data.DueDate,
    CompanyCode,
    CompanyLocation,
    UserID,
    isUpdateMode,
  ]);

  useEffect(() => {
    const loadGRNCashGridConfigs = async () => {
      try {
        let tabs;
        try {
          const jsonRes = await fetch(`${API}/config/FrmAPInvoice_MBC-grds.json`);
          if (!jsonRes.ok)
            throw new Error("AP Invoice grid JSON config not found");
          tabs = await jsonRes.json();
          if (
            Array.isArray(tabs) &&
            tabs.some((tab) => tab.GrdName && !Array.isArray(tab.columns))
          ) {
            const grouped = {};
            tabs.forEach((row) => {
              if (!row.GrdName) return;
              if (!grouped[row.GrdName]) {
                grouped[row.GrdName] = {
                  grdName: row.GrdName,
                  tabOrder: Number(row.TabOrder) || 999999,
                  columns: [],
                };
              }
              grouped[row.GrdName].columns.push(row);
            });
            tabs = Object.values(grouped);
          }
          if (!Array.isArray(tabs) || !tabs.length) {
            throw new Error("AP Invoice grid JSON is empty");
          }
        } catch {
          const res = await axios.post(`${API}/api/get-grid-configs`, {
            formName: "FrmAPInvoice_MBC",
          });
          tabs =
            res.data?.success === true && Array.isArray(res.data?.data)
              ? res.data.data
              : [];
        }

        tabs = Array.isArray(tabs) ? [...tabs] : [];

        tabs.sort((a, b) => {
          return Number(a.tabOrder || 999999) - Number(b.tabOrder || 999999);
        });

        tabs.forEach((tab) => {
          if (Array.isArray(tab.columns)) {
            tab.columns.sort((a, b) => {
              return Number(a.ColIndex || 0) - Number(b.ColIndex || 0);
            });
          }
        });

        console.log(
          "Sorted Grid Tabs:",
          tabs.map((tab) => ({
            grdName: tab.grdName,
            tabOrder: tab.tabOrder,
            columns: tab.columns,
          })),
        );

        if (!tabs.length) {
          setGridTabs([]);
          setGridConfigMap({});
          setGridRowsMap({});
          setActiveGridTab("");
          setGridCfg([]);

          setRowData([
            {
              FreightTaxable: "",
              _rowCreated: false,
            },
          ]);

          setAttachmentGridCfg([]);

          return;
        }
        const allConfigMap = {};
        const visibleConfigMap = {};

        const rowsMap = {};

        const gridNames = [];

        tabs.forEach((tab) => {
          const grdName = tab.grdName || tab.GrdName;

          if (!grdName) {
            return;
          }

          const allColumns = Array.isArray(tab.columns) ? tab.columns : [];
          const visibleColumns = allColumns.filter((column) =>
            isFieldVisible(column.Visible),
          );

          gridNames.push(grdName);

          allConfigMap[grdName] = allColumns;
          visibleConfigMap[grdName] = visibleColumns;

          // Keep all fields in row state so hidden GRDS values are preserved for save
          rowsMap[grdName] = [createDefaultGridRow(allColumns || [])];
        });

        setGridTabs(gridNames);
        setGridConfigMap(visibleConfigMap);
        setAllGridConfigMap(allConfigMap);

        setGridRowsMap(rowsMap);

        const firstGridName = gridNames[0];
        const attachmentTabName = gridNames.find((name) =>
          /attach/i.test(name),
        );
        setActiveGridTab(firstGridName);

        setGridCfg(visibleConfigMap[firstGridName] || []);

        setRowData(
          rowsMap[firstGridName] || [
            {
              FreightTaxable: "",
              _rowCreated: false,
            },
          ],
        );

        setAttachmentGridCfg(
          attachmentTabName ? visibleConfigMap[attachmentTabName] || [] : [],
        );
      } catch (err) {
        console.error("Grid configuration loading error:", err);

        toast.error("Failed to load grid configuration");
      }
    };

    loadGRNCashGridConfigs();
  }, []);

  const naturalSortValue = (value) => {
    const text = String(value ?? "");
    const parts = text.match(/\d+|[A-Za-z]+/g) || [text];

    return parts.map((part) => {
      if (/^\d+$/.test(part)) {
        return Number(part).toString().padStart(20, "0");
      }
      return part.toLowerCase();
    });
  };

  const compareRowKey = (a, b) => {
    const left = naturalSortValue(a);
    const right = naturalSortValue(b);
    const length = Math.max(left.length, right.length);

    for (let i = 0; i < length; i++) {
      const leftPart = left[i] ?? "";
      const rightPart = right[i] ?? "";

      if (leftPart === rightPart) continue;
      return leftPart < rightPart ? -1 : 1;
    }

    return 0;
  };

  const groupByLayout = (rows) => {
    const layout = {};

    rows.forEach((r) => {
      if (!r.GroupBox || !isFieldVisible(r.Visible)) return;

      if (!layout[r.GroupBox]) layout[r.GroupBox] = {};
      if (!layout[r.GroupBox][r.Row]) layout[r.GroupBox][r.Row] = [];

      layout[r.GroupBox][r.Row].push(r);
    });

    Object.keys(layout)
      .sort((a, b) => compareRowKey(a, b))
      .forEach((gb) => {
        const orderedRows = {};

        Object.keys(layout[gb])
          .sort((a, b) => compareRowKey(a, b))
          .forEach((rowKey) => {
            orderedRows[rowKey] = [...layout[gb][rowKey]].sort((a, b) => {
              const left = Number(a.ColIndex) || 0;
              const right = Number(b.ColIndex) || 0;
              return left - right;
            });
          });

        layout[gb] = orderedRows;
      });

    return Object.fromEntries(
      Object.keys(layout)
        .sort((a, b) => compareRowKey(a, b))
        .map((gb) => [gb, layout[gb]]),
    );
  };

  const layout = useMemo(() => groupByLayout(cfg), [cfg]);

  const HeaderLeft = layout.GBHL1 || {};
  const HeaderRight = layout.GBHR1 || {};
  const HeaderLeft2 = layout.GBHL2 || {};
  const HeaderRight2 = layout.GBHR2 || {};
  const FooterLeft = layout.GBFL1 || {};
  const FooterRight = layout.GBFR1 || {};

  const renderGroup = (group) =>
    Object.keys(group)
      .sort((a, b) => compareRowKey(a, b))
      .map((rowNo) => (
        <div className="erp-row" key={rowNo}>
          {group[rowNo].map((c) => (
            <div
              className="fld purchase-order-form-field"
              key={`${c.GroupBox}-${c.Row}-${c.ColIndex}-${c.ObjectCode || c.ColHdName}`}
            >
              {ctrl(c)}
            </div>
          ))}
        </div>
      ));

  const findPairedField = (currentCol, cfg) => {
    if (currentCol.endsWith("Code")) {
      return cfg.find(
        (c) =>
          c.ColHdName === currentCol.replace(/Code$/, "Name") &&
          c.ColType === "SelectBox",
      );
    }

    if (currentCol.endsWith("Name")) {
      return cfg.find(
        (c) =>
          c.ColHdName === currentCol.replace(/Name$/, "Code") &&
          c.ColType === "SelectBox",
      );
    }

    return null;
  };

  const getGLValuesFromBPRow = (row) => {
    if (!row) {
      return {
        GLCode: "",
        GLName: "",
      };
    }

    return {
      GLCode:
        row.GLCode ??
        row.Gl_Code ??
        row.GLACCOUNT ??
        row.GLAccount ??
        row.GLAccountCode ??
        "",

      GLName:
        row.GLName ??
        row.GL_Name ??
        row.GLACCOUNTNAME ??
        row.GLAccountName ??
        "",
    };
  };

  const getValueFromRow = (row, fieldCfg) => {
    if (!row || !fieldCfg) return "";
    if (fieldCfg.ColHdName && row[fieldCfg.ColHdName] !== undefined) {
      return row[fieldCfg.ColHdName];
    }
    if (fieldCfg.ColHdName.endsWith("Code") && row.Code !== undefined) {
      return row.Code;
    }

    if (fieldCfg.ColHdName.endsWith("Name") && row.Name !== undefined) {
      return row.Name;
    }

    if (row.TaxCode !== undefined) {
      return row.TaxCode;
    }
    return "";
  };

  const getOptionValue = (row, cfg) => {
    if (!row) return "";
    if (cfg.ColHdName.endsWith("Code"))
      return row.Code ?? row[Object.keys(row)[0]];
    if (cfg.ColHdName.endsWith("Name"))
      return row.Name ?? row[Object.keys(row)[1]];
    return row[Object.keys(row)[0]];
  };

  const getOptionLabel = (row) => {
    if (!row) return "";
    return (
      row.Name ||
      row.Description ||
      Object.values(row)[1] ||
      Object.values(row)[0]
    );
  };

  const ctrl = (c) => {
    let isReadOnly =
      isApprovedView || (isUpdateMode ? false : c.ReadOnly === "Y");
    const isFloat = c.FloatableLabel === "Y";
    const isDate = c.ColType === "DatePicker";
    const value = data[c.ColHdName] ?? "";

    if (!isUpdateMode && !isApprovedView && c.ColHdName === "OFreightAmt") {
      isReadOnly = data.OFreightTaxable !== "Y";
    }

    if (!isUpdateMode && !isApprovedView && c.ColHdName === "OInsuranceAmt") {
      isReadOnly = data.OInsuranceTaxable !== "Y";
    }

    if (!isUpdateMode && !isApprovedView && c.ColHdName === "OHandlingAmt") {
      isReadOnly = data.OHandlingTaxable !== "Y";
    }

    if (!isUpdateMode && !isApprovedView && c.ColHdName === "TCSBaseAmt") {
      isReadOnly = data.TCSBaseManual !== "Y";
    }

    if (!isUpdateMode && !isApprovedView && c.ColHdName === "Roff") {
      isReadOnly = data.NETAmount !== "Y";
    }

    /* ---------- CHECKBOX ---------- */
    if (c.ColType === "CheckBox") {
      return (
        <label className="chk-wrap">
          <input
            type="checkbox"
            className="purchase-order-premium-control"
            checked={value === "Y"}
            disabled={isReadOnly}
            onChange={(e) => {
              const checked = e.target.checked ? "Y" : "N";
              setData((prev) => {
                let updated = {
                  ...prev,
                  [c.ColHdName]: checked,
                };

                // Reset logic
                if (c.ColHdName === "TCSBaseManual") {
                  if (checked === "N") {
                    updated.TCSBaseAmt = updated.DocTotal;
                  }
                  if (
                    checked === "Y" &&
                    updated.TCSBaseAmt === updated.DocTotal
                  ) {
                    updated.TCSBaseAmt = "";
                  }
                }

                if (c.ColHdName === "NETAmount" && checked === "Y") {
                  updated.Roff = 0;
                }

                return updated;
              });
            }}
          />
          {isFloat && <span>{c.ColHdText}</span>}
        </label>
      );
    }

    /* ---------- BASE STYLE ---------- */
    const baseStyle = {
      width: c.ColWidth ? `${c.ColWidth}px` : "100%",
      backgroundColor: resolveColor(c.BackColor),
      color: c.ForeColor || "#000",
      border: c.InputBorder || "2px solid #666",
      borderRadius: c.InputBorderRadius || "4px",
      padding: c.InputPadding || "4px 6px",
      textAlign: c.TextAlignment?.toLowerCase() || "left",
      fontSize: "12px",
    };

    /* ---------- OVERFLOW CLICK ---------- */
    const handleOverflowClick = (e) => {
      if (e.target.scrollWidth > e.target.clientWidth) {
        setPopup({
          open: true,
          label: c.ColHdText,
          value,
        });
      }
    };

    /* ---------- SELECT BOX ---------- */
    if (c.ColType === "SelectBox") {
      return (
        <div className="flt-wrap">
          <input
            readOnly
            value={value}
            className="purchase-order-premium-control"
            style={{
              ...baseStyle,
              cursor: isApprovedView ? "not-allowed" : "pointer",
            }}
            onClick={async () => {
              if (isApprovedView) return;

              // ❌ BLOCK if customer not selected
              if (
                (c.ColHdName === "ShipToLocation" ||
                  c.ColHdName === "BillToLocation") &&
                !data.BPCode
              ) {
                alert("Please select Customer (BP Code / BP Name) first");
                return;
              }

              try {
                const cachedOptions = Array.isArray(c._QueryTable)
                  ? c._QueryTable
                  : [];
                const options = cachedOptions.length
                  ? cachedOptions
                  : (
                      await axios.post(
                        `${API}/api/get-ap-invoice-control-options`,
                        {
                          fieldName: c.ColHdName,
                          formData: {
                            CompCode: CompanyCode,
                            Location: CompanyLocation,
                            UserID: UserID,
                            BPCode: data.BPCode || "",
                            BPLocation: data.BillToLocation || "",
                            CompLocation: CompanyLocation,
                            RCM: "N",
                          },
                        },
                      )
                    ).data;

                const queryRows = Array.isArray(options) ? options : [];
                if (!queryRows.length) return;

                const cacheOptions = (field) =>
                  field.ColHdName === c.ColHdName
                    ? { ...field, _QueryTable: queryRows }
                    : field;

                setCfg((prev) => prev.map(cacheOptions));
                setAllCfg((prev) => prev.map(cacheOptions));

                setSelectPopup({
                  open: true,
                  field: c.ColHdName,
                  columns: Object.keys(queryRows[0]),
                  rows: queryRows,
                  search: "",
                });
              } catch (err) {
                toast.error(`${c.ColHdName} popup error: ${err.message}`);
              }
            }}
          />
          {isFloat && (
            <label className={value ? "filled" : ""}>{c.ColHdText}</label>
          )}
        </div>
      );
    }

    /* ---------- DROPDOWN BOX ---------- */
    if (c.ColType === "DropdownBox") {
      const shouldFloat = isFloat && (value !== "" || value === "");

      return (
        <div className="flt-wrap">
          <select
            className="purchase-order-premium-control"
            value={value || ""}
            disabled={isReadOnly}
            style={baseStyle}
            onFocus={async () => {
              if (c._QueryTable || !c.Query) return;

              try {
                const res = await axios.post(
                  `${API}/api/get-ap-invoice-control-options`,
                  {
                    fieldName: c.ColHdName,
                    formData: {
                      CompCode: CompanyCode,
                      Location: CompanyLocation,
                      UserID,
                      BPCode: data.BPCode || "",
                      BPLocation: data.BillToLocation || "",
                      CompLocation: CompanyLocation,
                      RCM: "N",
                    },
                  },
                );

                const options = Array.isArray(res.data) ? res.data : [];
                setCfg((prev) =>
                  prev.map((field) =>
                    field.ColHdName === c.ColHdName
                      ? { ...field, _QueryTable: options }
                      : field,
                  ),
                );
              } catch (err) {
                console.error(`${c.ColHdName} options error:`, err);
              }
            }}
            onChange={(e) => {
              const selectedValue = e.target.value;

              const selectedRow = c._QueryTable?.find(
                (r) => String(getOptionValue(r, c)) === selectedValue,
              );

              const pairedCfg = findPairedField(c.ColHdName, cfg);

              setData((prev) => {
                const updated = { ...prev };
                updated[c.ColHdName] = selectedValue;

                if (pairedCfg && selectedRow) {
                  updated[pairedCfg.ColHdName] = pairedCfg.ColHdName.endsWith(
                    "Code",
                  )
                    ? selectedRow.Code
                    : selectedRow.Name;
                }

                return updated;
              });
            }}
          >
            <option value="">Select</option>

            {c._QueryTable?.map((row, i) => {
              const optValue = getOptionValue(row, c);
              const optLabel = getOptionLabel(row);

              return (
                <option key={i} value={optValue}>
                  {optLabel}
                </option>
              );
            })}
          </select>

          {isFloat && (
            <label className={shouldFloat ? "filled" : ""}>{c.ColHdText}</label>
          )}
        </div>
      );
    }

    /* ---------- DATE PICKER (WITH FLOAT LABEL) ---------- */
    if (isDate) {
      const dateInput = (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            format="DD-MM-YYYY"
            value={value ? dayjs(value, "YYYY-MM-DD") : null}
            readOnly={isReadOnly} // only read-only if config says so
            onChange={(newValue) => {
              setData((p) => ({
                ...p,
                [c.ColHdName]: newValue ? newValue.format("YYYY-MM-DD") : "",
              }));
            }}
            slotProps={{
              popper: {
                className: "purchase-order-date-picker-popper",
              },
              desktopPaper: {
                className: "purchase-order-date-picker-paper",
              },
              mobilePaper: {
                className: "purchase-order-date-picker-paper",
              },
              textField: {
                className: "purchase-order-date-control",
                sx: {
                  width: baseStyle.width,
                },
                InputProps: {
                  disableUnderline: true,
                  style: {
                    height: "36px",
                    borderRadius: baseStyle.borderRadius,
                    border: "1px solid #c9d7e6",
                    backgroundColor:
                      "linear-gradient(180deg, #ffffff 0%, #f7fbff 100%)",
                    color: baseStyle.color,
                    fontSize: baseStyle.fontSize,
                    padding: "5px 14px",
                  },
                },
              },
            }}
          />
        </LocalizationProvider>
      );

      if (isFloat) {
        return (
          <div className="flt-wrap">
            {dateInput}
            <label className={`date-field-label ${value ? "filled" : ""}`}>
              {c.ColHdText}
            </label>
          </div>
        );
      }

      return dateInput;
    }

    /* ---------- REMARKS / HEADER NOTE TEXT EDITOR ---------- */
    const isRemarksField =
      String(c.ColHdName || "")
        .toLowerCase()
        .includes("remark") ||
      String(c.ColHdText || "")
        .toLowerCase()
        .includes("remark");

    if (isRemarksField) {
      const input = (
        <input
          type="text"
          value={value}
          style={baseStyle}
          className="ellipsis-input purchase-order-premium-control"
          readOnly
          onClick={() => {
            openItemDetailsPopup(
              "form",
              null,
              c.ColHdName,
              value,
              c.ColHdText || c.ColHdName || c.Tbl_Col_Name,
            );
          }}
        />
      );

      if (isFloat) {
        return (
          <div className="flt-wrap">
            {input}
            <label className={value ? "filled" : ""}>{c.ColHdText}</label>
          </div>
        );
      }

      return input;
    }

    /* ---------- ALL OTHER FIELDS (ELLIPSIS MODE) ---------- */
    const input = (
      <input
        type={c.ColType === "Number" ? "number" : "text"}
        value={value}
        style={baseStyle}
        className="ellipsis-input purchase-order-premium-control"
        readOnly={isReadOnly}
        onClick={!isReadOnly ? undefined : handleOverflowClick}
        onChange={(e) => {
          if (!isReadOnly) {
            setData((p) => ({
              ...p,
              [c.ColHdName]:
                c.ColType === "Number"
                  ? Number(e.target.value || 0)
                  : e.target.value,
            }));
          }
        }}
      />
    );

    if (isFloat) {
      return (
        <div className="flt-wrap">
          {input}
          <label className={value ? "filled" : ""}>{c.ColHdText}</label>
        </div>
      );
    }

    return input;
  };

  const resolveTextAlign = (dbAlign = "") => {
    const a = dbAlign.toLowerCase();

    if (a.includes("center")) return "center";
    if (a.includes("right")) return "right";
    return "left";
  };

  /**
   * Determine input type based on SQL data type
   * @param {string} dataType - SQL column data type from Tbl_Col_DataType
   * @returns {string} - Input type (text, number, date, checkbox)
   */
  const getInputTypeFromDataType = (dataType) => {
    if (!dataType) return "text";

    const dt = dataType.toLowerCase().trim();

    // Number types
    if (["int", "bigint", "smallint", "tinyint"].includes(dt)) {
      return "number-integer";
    }

    if (
      ["decimal", "float", "real", "numeric", "money", "smallmoney"].includes(
        dt,
      )
    ) {
      return "number-decimal";
    }

    // Date/Time types
    if (
      [
        "datetime",
        "datetime2",
        "smalldatetime",
        "date",
        "datetimeoffset",
      ].includes(dt)
    ) {
      return "date";
    }

    // Boolean types
    if (["bit", "boolean"].includes(dt)) {
      return "checkbox";
    }

    // String types (default)
    if (
      ["varchar", "nvarchar", "char", "nchar", "text", "ntext"].includes(dt)
    ) {
      return "text";
    }

    return "text";
  };

  /**
   * Convert and validate value based on data type
   * @param {*} value - Raw value
   * @param {string} dataType - SQL column data type
   * @returns {*} - Converted value
   */
  const convertValueByDataType = (value, dataType) => {
    if (value === null || value === undefined || value === "") return "";

    const inputType = getInputTypeFromDataType(dataType);

    switch (inputType) {
      case "number-integer":
        return parseInt(value) || 0;

      case "number-decimal":
        return parseFloat(value) || 0;

      case "date":
        return String(value);

      case "checkbox":
        return value === "Y" || value === true || value === 1 ? "Y" : "N";

      default:
        return String(value);
    }
  };

  const isNumericDataType = (dataType) => {
    const inputType = getInputTypeFromDataType(dataType);
    return inputType === "number-integer" || inputType === "number-decimal";
  };

  const formatDateForBackend = (value) => {
    if (value === null || value === undefined || value === "") return null;

    const trimmed = String(value).trim();
    if (!trimmed) return null;

    const parsed = dayjs(value, [
      "YYYY-MM-DD",
      "DD-MM-YYYY",
      "DD/MM/YYYY",
      "MM/DD/YYYY",
    ]);
    if (!parsed.isValid()) return null;

    return parsed.format("YYYY-MM-DD");
  };

  const normalizeInsertValue = (value, dataType) => {
    if (value === null || value === undefined) {
      return isNumericDataType(dataType)
        ? 0
        : getInputTypeFromDataType(dataType) === "date"
          ? null
          : "";
    }

    if (typeof value === "string" && value.trim() === "") {
      return isNumericDataType(dataType)
        ? 0
        : getInputTypeFromDataType(dataType) === "date"
          ? null
          : "";
    }

    if (typeof value === "number" && !Number.isFinite(value)) {
      return isNumericDataType(dataType)
        ? 0
        : getInputTypeFromDataType(dataType) === "date"
          ? null
          : "";
    }

    if (getInputTypeFromDataType(dataType) === "date") {
      return formatDateForBackend(value);
    }

    return value;
  };

  const sanitizeTableName = (value) => {
    if (!value && value !== 0) return "";

    const trimmed = String(value).trim();
    if (!trimmed) return "";

    // Temp table placeholders created by the DB procedure are not real table names.
    if (trimmed.startsWith("##") || trimmed.startsWith("#")) {
      return "";
    }

    return trimmed;
  };

  const filteredFindResults = useMemo(() => {
    const term = searchTerm.trim().toLowerCase();
    if (!term) return findResults;

    return findResults.filter((row) => {
      return [row.DocEntry, row.ObjectCode, row.Series, row.DocNum, row.DocDate]
        .map((value) => String(value || "").toLowerCase())
        .some((text) => text.includes(term));
    });
  }, [findResults, searchTerm]);

  const pageCount = useMemo(
    () => Math.max(1, Math.ceil(filteredFindResults.length / findPageSize)),
    [filteredFindResults.length, findPageSize],
  );

  const currentPageRows = useMemo(() => {
    const start = pageIndex * findPageSize;
    return filteredFindResults.slice(start, start + findPageSize);
  }, [filteredFindResults, pageIndex, findPageSize]);

  const firstDisplayedDetail = filteredFindResults.length
    ? pageIndex * findPageSize + 1
    : 0;
  const lastDisplayedDetail = Math.min(
    (pageIndex + 1) * findPageSize,
    filteredFindResults.length,
  );

  useEffect(() => {
    if (pageIndex >= pageCount) {
      setPageIndex(Math.max(0, pageCount - 1));
    }
  }, [pageCount, pageIndex]);

  useEffect(() => {
    setPageIndex(0);
  }, [searchTerm]);

  const handleFindPageSizeChange = (event) => {
    setFindPageSize(Number(event.target.value));
    setPageIndex(0);
  };

  const canPreviousPage = pageIndex > 0;
  const canNextPage = pageIndex < pageCount - 1;
  const previousPage = () => setPageIndex((prev) => Math.max(prev - 1, 0));
  const nextPage = () =>
    setPageIndex((prev) => Math.min(prev + 1, pageCount - 1));

  const currentGridRows = useMemo(() => {
    const activeGridKey = activeGridTab || gridTabs[0] || "main";
    return gridRowsMap[activeGridKey] || rowData || [];
  }, [activeGridTab, gridTabs, gridRowsMap, rowData]);

  const contentsGridKey = useMemo(() => {
    const keys = Array.isArray(gridTabs) ? gridTabs.filter(Boolean) : [];

    const exactMatch = keys.find((key) =>
      /^contents?$/i.test(String(key).trim()),
    );
    if (exactMatch) return exactMatch;

    const partialMatch = keys.find((key) => /contents?/i.test(String(key)));
    if (partialMatch) return partialMatch;

    return activeGridTab || keys[0] || "main";
  }, [activeGridTab, gridTabs]);

  const contentsGridRows = useMemo(() => {
    return gridRowsMap[contentsGridKey] || [];
  }, [contentsGridKey, gridRowsMap]);

  const gridTotalValue = useMemo(() => {
    return (currentGridRows || []).reduce((sum, row) => {
      const value = row.GrdColTotalValue ?? 0;
      const number = Number(value);

      return sum + (Number.isFinite(number) ? number : 0);
    }, 0);
  }, [currentGridRows]);

  useEffect(() => {
    const currentGridTab = activeGridTab || gridTabs[0] || "";

    if (
      previousGridTabRef.current &&
      previousGridTabRef.current !== currentGridTab
    ) {
      previousGridTabRef.current = currentGridTab;
      return;
    }

    previousGridTabRef.current = currentGridTab;

    setData((prev) => {
      const baseTotal = Number(gridTotalValue || 0);
      const fixedNetAmount = Number(baseTotal.toFixed(2));
      const isRoffActive = prev.ChkRoff === "Y";
      const roundedDocTotal = isRoffActive
        ? Number(Math.round(baseTotal).toFixed(2))
        : fixedNetAmount;
      const roffValue = isRoffActive
        ? Number((roundedDocTotal - fixedNetAmount).toFixed(2))
        : 0;

      const nextState = {
        ...prev,
        NETAmount: fixedNetAmount,
        DocTotal: roundedDocTotal,
        Roff: roffValue,
        TDSBaseAmt:
          prev.TDSBaseManual === "Y" ? prev.TDSBaseAmt : fixedNetAmount,
      };

      if (
        prev.DocTotal === nextState.DocTotal &&
        prev.NETAmount === nextState.NETAmount &&
        prev.Roff === nextState.Roff
      ) {
        return prev;
      }

      return nextState;
    });
  }, [
    activeGridTab,
    gridTabs,
    gridTotalValue,
    data.ChkRoff,
    data.TDSBaseManual,
  ]);

  useEffect(() => {
    const loadGridCalculations = async () => {
      if (!gridTabs.length) return;

      try {
        const grdName = activeGridTab || gridTabs[0];

        const res = await axios.post(`${API}/api/get-grid-calculations`, {
          formName: "FrmAPInvoice_MBC",
          grdName: grdName,
        });

        console.log("Grid Calculation Response:", grdName, res.data);

        if (res.data?.success) {
          setGridCalc(res.data.data || []);
        } else {
          setGridCalc([]);
        }
      } catch (err) {
        console.error("Grid Calculation load error:", err);

        setGridCalc([]);
      }
    };

    loadGridCalculations();
  }, [gridTabs, activeGridTab]);

  const applyHeaderValuesToGridRow = (row = {}, cfg = []) => {
    const headerCompCode = data.CompCode ?? CompanyCode ?? "";
    const headerLocation = data.Location ?? CompanyLocation ?? "";
    const nextRow = {
      ...row,
      GrdColCompCode: headerCompCode,
      GrdColLocation: headerLocation,
    };

    (cfg || []).forEach((column) => {
      const fieldName = column?.ColHdName;
      if (!fieldName) return;

      const isCompCodeField = /CompCode$/i.test(fieldName);
      const isLocationField = /Location$/i.test(fieldName);

      if (isCompCodeField && nextRow[fieldName] === undefined) {
        nextRow[fieldName] = headerCompCode;
      }

      if (isLocationField && nextRow[fieldName] === undefined) {
        nextRow[fieldName] = headerLocation;
      }
    });

    return nextRow;
  };

  const ensureGridDateDefaults = (row = {}, cfg = []) => {
    const nextRow = { ...row };

    (cfg || []).forEach((column) => {
      const field = getGridFieldName(column);
      const inputType = getInputTypeFromDataType(column.Tbl_Col_DataType);
      const isDateColumn =
        inputType === "date" ||
        column.ColType === "DataGridViewDatePickerColumn";

      if (!field || !isDateColumn) return;

      const currentValue = nextRow[field];
      if (
        currentValue === null ||
        currentValue === undefined ||
        String(currentValue).trim() === ""
      ) {
        nextRow[field] = dayjs().format("YYYY-MM-DD");
      }
    });

    return nextRow;
  };

  const createDefaultGridRow = (cfg = []) => {
    let row = {
      _rowCreated: false,
    };

    row = ensureGridDateDefaults(row, cfg);

    // Header values → Grid values
    row = applyHeaderValuesToGridRow(row, cfg);

    return row;
  };

  useEffect(() => {
    if (!gridTabs.length) return;

    setGridRowsMap((prev) => {
      const updated = { ...prev };

      gridTabs.forEach((gridKey) => {
        const rows = updated[gridKey] || [];
        const cfg = gridConfigMap[gridKey] || [];

        updated[gridKey] = rows.map((row) =>
          applyHeaderValuesToGridRow(row, cfg),
        );
      });

      return updated;
    });
  }, [data.CompCode, data.Location, CompanyCode, CompanyLocation, gridTabs]);

  const getGridState = (gridKey = activeGridTab || gridTabs[0] || "main") => {
    const cfg = gridConfigMap[gridKey] || [];
    const rows = gridRowsMap[gridKey] || [createDefaultGridRow(cfg)];

    return {
      cfg,
      rows,
      setRows: (updater) => {
        setGridRowsMap((prev) => ({
          ...prev,
          [gridKey]: updater(prev[gridKey] || [createDefaultGridRow(cfg)]),
        }));
      },
    };
  };

  const updateGridRowsByKey = (
    gridKey = activeGridTab || gridTabs[0] || "main",
    updater,
  ) => {
    const gridState = getGridState(gridKey);
    gridState.setRows((prev) => updater(prev));
  };

  const handleGridPopupOpen = async (c, rowIndex, gridKey = "main") => {
    if (c.Popup !== "Y" || !c.PopupQuery) {
      return;
    }

    try {
      const res = await axios.post(`${API}/api/get-grid-popup-data`, {
        popupQuery: c.PopupQuery,

        params: {
          CompCode: CompanyCode,
          Location: CompanyLocation,
          UserID: UserID,

          BPCode: data.BPCode || "",

          BPLocation: data.BillToLocation || "",

          CompLocation: CompanyLocation,

          RCM: "N",
        },
      });

      if (!Array.isArray(res.data) || res.data.length === 0) {
        toast.warning("No data found.");
        return;
      }

      setGridPopup({
        open: true,

        rowIndex,

        field: getGridFieldName(c),

        columns: Object.keys(res.data[0]),

        rows: res.data,

        search: "",

        gridKey,
      });
    } catch (err) {
      console.error("Grid popup error:", err);

      toast.error("Unable to load popup data.");
    }
  };

  const openLinePopup = (rowIndex) => {
    const activeRows = currentGridRows;
    const row = activeRows[rowIndex] || {};
    setLinePopup({
      open: true,
      rowIndex,
      row: applyGridCalculations(row),
    });
  };

  const closeLinePopup = () => {
    setLinePopup((prev) => ({ ...prev, open: false }));
  };

  const handleLinePopupFieldChange = (field, value) => {
    setLinePopup((prev) => {
      const updatedRow = {
        ...prev.row,
        [field]:
          value === "" || value === null
            ? ""
            : isNaN(value)
              ? value
              : Number(value),
      };

      return {
        ...prev,
        row: applyGridCalculations(updatedRow),
      };
    });
  };

  const saveLinePopup = () => {
    if (linePopup.rowIndex === null) return;

    const activeGridKey = activeGridTab || gridTabs[0] || "main";
    const activeRows = currentGridRows;

    setGridRowsMap((prev) => {
      const updated = [...(prev[activeGridKey] || activeRows)];
      const currentRow = { ...linePopup.row };
      const savedRow = applyGridCalculations(currentRow);
      savedRow._rowCreated = true;

      updated[linePopup.rowIndex] = savedRow;

      if (
        linePopup.rowIndex === updated.length - 1 &&
        !updated[linePopup.rowIndex]?._rowCreated
      ) {
        updated.push({ FreightTaxable: "", _rowCreated: false });
      }

      return {
        ...prev,
        [activeGridKey]: updated,
      };
    });

    setLinePopup((prev) => ({ ...prev, open: false }));
  };

  const loadGridComboData = async (c) => {
    if (!c.PopupQuery) return;

    // already loaded → skip
    if (gridComboCache[c.Tbl_Col_Name]) return;

    try {
      const res = await axios.post(`${API}/api/get-grid-popup-data`, {
        popupQuery: c.PopupQuery,
        params: {
          CompCode: CompanyCode,
          Location: CompanyLocation,
          UserID: UserID,
        },
      });

      setGridComboCache((prev) => ({
        ...prev,
        [getGridFieldName(c)]: res.data || [],
      }));
    } catch (err) {
      console.error("Grid Combo load error:", err);
    }
  };

  const findGridPairedField = (currentCol, gridCfg) => {
    if (!currentCol) return null;

    const normalizedCurrentCol = currentCol.replace(/^GrdCol/, "");

    if (normalizedCurrentCol.endsWith("Code")) {
      return gridCfg.find(
        (c) =>
          getGridFieldName(c) === normalizedCurrentCol.replace(/Code$/, "Name"),
      );
    }

    if (normalizedCurrentCol.endsWith("Name")) {
      return gridCfg.find(
        (c) =>
          getGridFieldName(c) === normalizedCurrentCol.replace(/Name$/, "Code"),
      );
    }

    return null;
  };

  const mapPopupRowToGridRow = (
    currentRow,
    popupRow,
    gridCfg,
    clickedField,
  ) => {
    const updatedRow = {
      ...currentRow,
    };

    if (!popupRow || !gridCfg?.length) {
      return updatedRow;
    }

    const getPopupValue = (candidates) => {
      const normalizedKeys = new Map();
      Object.keys(popupRow || {}).forEach((key) => {
        normalizedKeys.set(String(key).toLowerCase(), popupRow[key]);
      });

      for (const key of candidates) {
        if (!key) continue;
        const match = normalizedKeys.get(String(key).toLowerCase());
        if (match !== undefined && match !== null) {
          return match;
        }
      }
      return undefined;
    };

    gridCfg.forEach((column) => {
      const gridField = getGridFieldName(column);
      const dbField = column?.Tbl_Col_Name || "";

      if (!gridField) return;

      const candidateKeys = [
        gridField,
        dbField,
        gridField.replace(/^Grd[A-Za-z0-9]+/, ""),
        gridField.replace(/^GrdCol/, ""),
        gridField.replace(/^Grd/, ""),
        dbField.replace(/^Grd[A-Za-z0-9]+/, ""),
        gridField.replace(/([a-z])([A-Z])/g, "$1 $2").trim(),
        dbField.replace(/([a-z])([A-Z])/g, "$1 $2").trim(),
      ].filter(Boolean);

      const mappedValue = getPopupValue(candidateKeys);
      if (mappedValue !== undefined) {
        updatedRow[gridField] = mappedValue;
        if (dbField) updatedRow[dbField] = mappedValue;
      }
    });

    if (clickedField) {
      const clickedCfg = gridCfg.find(
        (c) => getGridFieldName(c) === clickedField,
      );

      const pairedCfg = findGridPairedField(clickedField, gridCfg);

      if (clickedCfg) {
        const clickedNormalized = clickedField.replace(/^GrdCol/, "");

        /*
         * Find Code value
         */
        const codeValue =
          popupRow.Code ??
          popupRow[`${clickedNormalized}`] ??
          popupRow[
            Object.keys(popupRow).find((key) =>
              key.toLowerCase().includes("code"),
            )
          ];

        /*
         * Find Name value
         */
        const nameValue =
          popupRow.Name ??
          popupRow[clickedNormalized.replace(/Code$/i, "Name")] ??
          popupRow[
            Object.keys(popupRow).find((key) =>
              key.toLowerCase().includes("name"),
            )
          ];

        if (String(clickedField).toLowerCase().endsWith("code")) {
          if (codeValue !== undefined && codeValue !== null) {
            updatedRow[clickedField] = codeValue;
          }

          if (pairedCfg && nameValue !== undefined && nameValue !== null) {
            updatedRow[getGridFieldName(pairedCfg)] = nameValue;
          }
        }

        if (String(clickedField).toLowerCase().endsWith("name")) {
          if (nameValue !== undefined && nameValue !== null) {
            updatedRow[clickedField] = nameValue;
          }

          if (pairedCfg && codeValue !== undefined && codeValue !== null) {
            updatedRow[getGridFieldName(pairedCfg)] = codeValue;
          }
        }
      }
    }

    const normalizedClickedField = (clickedField || "").replace(/^GrdCol/, "");
    const normalizedClickedFieldKey = normalizedClickedField.toLowerCase();

    if (
      normalizedClickedFieldKey === "itemcode" ||
      normalizedClickedFieldKey === "itemname"
    ) {
      const itemCode =
        popupRow.ItemCode ?? popupRow.Code ?? updatedRow.ItemCode ?? "";

      const itemName =
        popupRow.ItemName ?? popupRow.Name ?? updatedRow.ItemName ?? "";

      const itemDetails =
        popupRow.ItemDetails ??
        popupRow.ItemDesc ??
        popupRow.Description ??
        updatedRow.ItemDetails ??
        "";

      const itemUom =
        popupRow.UoM ?? popupRow.UOM ?? popupRow.Uom ?? updatedRow.UoM ?? "";

      const setItemValue = (itemField, value) => {
        const matchingFields = gridCfg
          .map((column) => getGridFieldName(column))
          .filter(
            (fieldName) =>
              String(fieldName)
                .replace(/^GrdCol/, "")
                .toLowerCase() === itemField.toLowerCase(),
          );

        matchingFields.forEach((fieldName) => {
          updatedRow[fieldName] = value;
        });
        updatedRow[itemField] = value;
      };

      setItemValue("ItemCode", itemCode);
      setItemValue("ItemName", itemName);
      setItemValue("ItemDetails", itemDetails);
      setItemValue("UoM", itemUom);
      if (clickedField === "TaxCode") {
        updatedRow.TaxCode = popupRow.TaxCode ?? "";

        updatedRow.SGSTRate = popupRow.SGSTRate ?? "";

        updatedRow.IGSTRate = popupRow.IGSTRate ?? "";
      }

      [
        "Price",
        "Rate",
        "UnitPrice",
        "PurchasePrice",
        "HSNCode",
        "HSN",
        "TaxCode",
        "TaxName",
        "SGSTRate",
        "CGSTRate",
        "IGSTRate",
        "Warehouse",
        "WarehouseCode",
        "WhsCode",
        "WhsName",
        "PackSize",
        "Quantity",
      ].forEach((field) => {
        if (popupRow[field] !== undefined && popupRow[field] !== null) {
          updatedRow[field] = popupRow[field];
        }
      });
    }

    if (normalizedClickedField === "HeadValue") {
      updatedRow.HeadValue =
        getPopupValue(["HeadValue", "Head", "Name", "Value", "Description"]) ??
        updatedRow.HeadValue ??
        "";

      updatedRow.BaseLineId =
        getPopupValue([
          "BaseLineId",
          "BaseLineID",
          "BaseLine",
          "LineID",
          "LineId",
        ]) ??
        updatedRow.BaseLineId ??
        "";

      updatedRow.Heading =
        getPopupValue(["Heading", "Title", "HeadName", "Description"]) ??
        updatedRow.Heading ??
        "";

      updatedRow.SLNo =
        getPopupValue([
          "SLNo",
          "SLNO",
          "SlNo",
          "LineNo",
          "SerialNo",
          "No",
          "SN",
        ]) ??
        updatedRow.SLNo ??
        "";

      updatedRow.GrdColHeadValue = updatedRow.HeadValue;
      updatedRow.GrdColBaseLineId = updatedRow.BaseLineId;
      updatedRow.GrdColHeading = updatedRow.Heading;
      updatedRow.GrdColSLNo = updatedRow.SLNo;
    }

    if (normalizedClickedField === "TaxCode") {
      updatedRow.TaxCode =
        popupRow.TaxCode ?? popupRow.Code ?? updatedRow.TaxCode ?? "";

      updatedRow.SGSTRate = Number(
        popupRow.SGSTRate ?? popupRow.SGST ?? updatedRow.SGSTRate ?? 0,
      );

      updatedRow.CGSTRate = Number(
        popupRow.CGSTRate ?? popupRow.CGST ?? updatedRow.CGSTRate ?? 0,
      );

      updatedRow.IGSTRate = Number(
        popupRow.IGSTRate ?? popupRow.IGST ?? updatedRow.IGSTRate ?? 0,
      );
    }

    Object.keys(updatedRow).forEach((key) => {
      if (updatedRow[key] === undefined) {
        delete updatedRow[key];
      }
    });

    return updatedRow;
  };

  const getGridFieldName = (c) => c?.ColHdName || c?.Tbl_Col_Name || "";

  const getGridColumnWidth = (c = {}) => {
    const field = getGridFieldName(c);
    const dbField = c?.Tbl_Col_Name || "";
    const savedWidth = field
      ? (gridColumnWidths[field] ?? gridColumnWidths[dbField])
      : undefined;

    const rawWidth = Number(
      c?.ColWidth ?? c?.width ?? c?.FillWeight ?? c?.MidWidth ?? 150,
    );

    if (Number.isFinite(Number(savedWidth))) {
      return Number(savedWidth);
    }

    if (Number.isFinite(rawWidth) && rawWidth > 0) {
      return rawWidth;
    }

    return 150;
  };

  const openItemDetailsPopup = (
    gridKey,
    rowIndex,
    field,
    value,
    title = "Item Details",
  ) => {
    setItemDetailsPopup({
      open: true,
      gridKey,
      rowIndex,
      field,
      value: value || "",
      title,
    });
  };

  const closeItemDetailsPopup = () => {
    setItemDetailsPopup((prev) => ({ ...prev, open: false }));
  };

  const saveItemDetailsPopup = () => {
    if (isApprovedView) return;

    if (itemDetailsPopup.gridKey === "form") {
      setData((prev) => ({
        ...prev,
        [itemDetailsPopup.field]: itemDetailsPopup.value,
      }));
      closeItemDetailsPopup();
      return;
    }

    if (itemDetailsPopup.rowIndex === null) return;

    updateGridRowsByKey(itemDetailsPopup.gridKey, (rows) => {
      const updatedRows = [...rows];
      if (!updatedRows[itemDetailsPopup.rowIndex]) return rows;

      updatedRows[itemDetailsPopup.rowIndex] = {
        ...updatedRows[itemDetailsPopup.rowIndex],
        [itemDetailsPopup.field]: itemDetailsPopup.value,
      };
      return updatedRows;
    });

    closeItemDetailsPopup();
  };

  // Get ordered header columns with display names (ColHdName)
  const getOrderedHeaderColumns = () => {
    const ordered = [];
    const seen = new Set();

    const addColumn = (column) => {
      if (!column) return;

      const field = column.ColHdName || column.Tbl_Col_Name || "";

      if (!field) return;

      if (
        field === "_rowCreated" ||
        field === "isExisting" ||
        field === "_rowId" ||
        field === "file"
      ) {
        return;
      }

      if (!seen.has(field)) {
        seen.add(field);
        ordered.push(field);
      }
    };

    (allCfg.length ? allCfg : cfg || []).forEach(addColumn);

    if (isUpdateMode && !seen.has("DocEntry")) {
      ordered.push("DocEntry");
    }

    return ordered;
  };

  const getOrderedHeaderColumnsForDB = () => {
    const ordered = [];
    const seen = new Set();

    const addColumn = (column) => {
      if (!column) return;

      // Only include fields with non-blank Tbl_Col_Name
      const dbField = column?.Tbl_Col_Name;
      if (!dbField || dbField.trim() === "") return;

      if (
        dbField === "_rowCreated" ||
        dbField === "isExisting" ||
        dbField === "_rowId" ||
        dbField === "file"
      ) {
        return;
      }

      if (!seen.has(dbField)) {
        seen.add(dbField);
        ordered.push(dbField);
      }
    };

    (allCfg.length ? allCfg : cfg || []).forEach(addColumn);

    if (isUpdateMode && !seen.has("DocEntry")) {
      ordered.push("DocEntry");
    }

    return ordered;
  };

  const convertFormula = (formula) => {
    if (!formula) return "0";

    const skipWords = new Set([
      "Math",
      "true",
      "false",
      "null",
      "undefined",
      "trim",
      "includes",
      "toUpperCase",
      "toLowerCase",
    ]);

    return formula.replace(
      /(".*?"|'.*?'|\b[A-Za-z_][A-Za-z0-9_]*\b)/g,
      (token) => {
        // ✅ string literal → keep as-is
        if (token.startsWith('"') || token.startsWith("'")) {
          return token;
        }

        // ✅ JS keywords / functions
        if (skipWords.has(token)) {
          return token;
        }

        // ✅ column reference
        return `((row['${token}']) || 0)`;
      },
    );
  };

  const applyGridCalculations = (row) => {
    let updatedRow = {
      ...row,
    };

    if (!Array.isArray(gridCalc) || gridCalc.length === 0) {
      return updatedRow;
    }

    const orderedCalcs = [...gridCalc]
      .filter(
        (calc) =>
          calc && calc.TargetColumn && (calc.FormulaDesc || calc.Formula),
      )
      .sort(
        (a, b) => Number(a.FunctionLineID || 0) - Number(b.FunctionLineID || 0),
      );

    orderedCalcs.forEach((calc) => {
      try {
        const formula = calc.FormulaDesc || calc.Formula || "0";

        const expression = convertFormula(formula);

        // console.log("GRID CALC:", {
        //   FunctionLineID: calc.FunctionLineID,
        //   TargetColumn: calc.TargetColumn,
        //   Formula: formula,
        //   Expression: expression,
        //   Row: updatedRow,
        // });

        const safe = (value, defaultValue = 0) => {
          if (value === null || value === undefined || value === "") {
            return defaultValue;
          }

          const number = Number(value);

          return Number.isNaN(number) ? defaultValue : number;
        };

        const fn = new Function(
          "row",
          "safe",
          `
                    return (${expression});
                `,
        );

        let result = fn(updatedRow, safe);

        // Get the data type of target column for proper conversion
        const targetColCfg = gridCfg?.find(
          (c) => getGridFieldName(c) === calc.TargetColumn,
        );
        const targetDataType = targetColCfg?.Tbl_Col_DataType;

        // Convert numeric result or use Tbl_Col_DataType conversion
        if (typeof result === "number" && Number.isFinite(result)) {
          result = Number(result.toFixed(2));
        }

        // Apply data type conversion to result if available
        if (result !== null && result !== undefined && targetDataType) {
          updatedRow[calc.TargetColumn] = convertValueByDataType(
            result,
            targetDataType,
          );
        } else {
          updatedRow[calc.TargetColumn] =
            result === null || result === undefined || Number.isNaN(result)
              ? 0
              : result;
        }

        console.log("GRID CALC RESULT:", {
          TargetColumn: calc.TargetColumn,
          TargetDataType: targetDataType,
          Result: result,
          ConvertedResult: updatedRow[calc.TargetColumn],
        });
      } catch (err) {
        console.error("Grid calculation failed:", {
          FunctionLineID: calc.FunctionLineID,
          TargetColumn: calc.TargetColumn,
          Formula: calc.FormulaDesc,
          Row: updatedRow,
          Error: err.message,
        });
      }
    });

    return updatedRow;
  };

  const handleCellChangeForGrid = (
    gridKey = "main",
    rowIndex,
    field,
    value,
  ) => {
    const gridState = getGridState(gridKey);

    gridState.setRows((prev) => {
      const updated = [...prev];

      if (!updated[rowIndex]) {
        return prev;
      }

      let row = {
        ...updated[rowIndex],
      };

      // Get column configuration to access Tbl_Col_DataType
      const columnCfg = (gridConfigMap[gridKey] || []).find(
        (c) => getGridFieldName(c) === field,
      );

      // Convert value based on Tbl_Col_DataType
      if (value === "" || value === null || value === undefined) {
        row[field] = "";
      } else if (columnCfg?.Tbl_Col_DataType) {
        row[field] = convertValueByDataType(value, columnCfg.Tbl_Col_DataType);
      } else if (columnCfg?.ColType === "Number") {
        // Fallback to old logic if Tbl_Col_DataType not available
        row[field] = Number(value);
      } else {
        row[field] = value;
      }

      console.log("CELL CHANGE:", {
        gridKey,
        rowIndex,
        field,
        value,
        dataType: columnCfg?.Tbl_Col_DataType,
        convertedValue: row[field],
        rowBeforeCalculation: row,
      });

      // Apply row-level formulas
      row = applyGridCalculations(row);

      console.log("ROW AFTER CALCULATION:", row);

      // Auto create next row
      if (field === "ItemCode" && value && !row._rowCreated) {
        row._rowCreated = true;

        updated[rowIndex] = row;

        updated.push({
          _rowCreated: false,
        });

        return updated;
      }

      updated[rowIndex] = row;

      return updated;
    });
  };

  const renderGridSection = (title, cfg, rows, gridKey) => {
    const gridRows = (rows || []).map((row, index) => ({
      ...row,
      id: row.id ?? row._rowId ?? `${gridKey}-${index}`,
    }));

    const columns = [
      {
        field: "__action__",
        headerName: "Action",
        width: 80,
        minWidth: 80,
        sortable: false,
        filterable: false,
        resizable: true,
        disableColumnMenu: true,
        renderCell: (params) => {
          const rowIndex = gridRows.findIndex((row) => row.id === params.id);
          const deleteCurrentRow = () => {
            setGridRowsMap((prev) => ({
              ...prev,
              [gridKey]: (prev[gridKey] || gridRows).filter(
                (_, idx) => idx !== rowIndex,
              ),
            }));
          };

          return (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "8px",
                width: "100%",
              }}
            >
              {rowIndex >= 0 && (
                <button
                  type="button"
                  className="purchase-order-delete-row-button"
                  title="Delete row"
                  onClick={deleteCurrentRow}
                >
                  <MdDeleteOutline size={18} />
                </button>
              )}
            </div>
          );
        },
      },
    ];

    cfg.forEach((c, colIndex) => {
      const field = getGridFieldName(c) || `grid-col-${colIndex}`;
      const isButton = c.ColType === "DataGridViewButtonColumn";
      const isTermsGrid = /termcond/i.test(String(gridKey || ""));
      const isGridDate = c.ColType === "DataGridViewDatePickerColumn";
      const isCombo = c.ColType === "DataGridViewComboBoxColumn";
      const inputType = getInputTypeFromDataType(c.Tbl_Col_DataType);
      const isNumberField =
        inputType === "number-integer" || inputType === "number-decimal";
      const isDateField = inputType === "date" || isGridDate;
      const isCheckboxField = inputType === "checkbox";
      const isSerialColumn =
        !field ||
        field === "LineID" ||
        (/^(sl|serial|line)\s*no$/i.test(
          (c.ColHdText || c.ColHdName || c.Tbl_Col_Name || "").trim(),
        ) &&
          !/^GrdColSLNo$/i.test(String(field || "")) &&
          !(
            String(c.Tbl_Col_Name || "")
              .trim()
              .toLowerCase() === "slno"
          ));

      columns.push({
        field,
        headerName: c.ColHdText || c.ColHdName || c.Tbl_Col_Name || "",
        width: getGridColumnWidth(c),
        minWidth: 50,
        sortable: false,
        filterable: false,
        resizable: true,
        disableColumnMenu: true,
        renderCell: (params) => {
          const row = params.row;
          const rowIndex = gridRows.findIndex((item) => item.id === params.id);
          let isReadOnly =
            isApprovedView || (isUpdateMode ? false : c.ReadOnly === "TRUE");
          const isPopup = c.Popup === "Y";
          const inputStyle = {
            background: ` ${resolveColor(c.BackColor)} `,
            textAlign: "left",
            height: "100%",
            border: "1px solid #d9e3f0",
            borderRadius: "10px",
            padding: "8px 10px",
            fontSize: "12px",
            color: "#17212f",
            fontWeight: 500,
            width: getGridColumnWidth(c),
            minWidth: 50,
            outline: "none",
            transition: "all 0.2s ease",
          };

          if (isCombo) {
            return (
              <select
                value={row[field] ?? ""}
                disabled={isReadOnly}
                style={{
                  // width: getGridColumnWidth(c),
                  minWidth: 50,
                  fontSize: "12px",
                  background: ` ${resolveColor(c.BackColor)} `,
                  textAlign: resolveTextAlign(c.TextAlignment),
                  cursor: isReadOnly ? "not-allowed" : "pointer",
                  border: "1px solid #d9e3f0",
                  borderRadius: "10px",
                  padding: "8px 10px",
                  color: "#17212f",
                  fontWeight: 500,
                  boxShadow: "inset 0 1px 2px rgba(15, 23, 42, 0.04)",
                }}
                onFocus={() => loadGridComboData(c)}
                onChange={(e) => {
                  handleCellChangeForGrid(
                    gridKey,
                    rowIndex,
                    field,
                    e.target.value,
                  );
                }}
              >
                <option value="">Select</option>
                {(gridComboCache[field] || []).map((opt, idx) => {
                  const optValue =
                    opt.Code ??
                    opt.Value ??
                    opt[field] ??
                    opt[Object.keys(opt)[0]];
                  const optLabel =
                    opt.Name ??
                    opt.Description ??
                    opt[Object.keys(opt)[1]] ??
                    optValue;

                  return (
                    <option key={idx} value={optValue}>
                      {optLabel}
                    </option>
                  );
                })}
              </select>
            );
          }

          if (isButton && !isTermsGrid) {
            return !row.isExisting && rowIndex !== 0 ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                }}
              >
                <div
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "28px",
                    height: "28px",
                    borderRadius: "9px",
                    background: "linear-gradient(135deg, #fee2e2, #fecaca)",
                    color: "#b91c1c",
                    boxShadow: "0 4px 10px rgba(220, 38, 38, 0.12)",
                  }}
                >
                  <MdDeleteOutline
                    title="Delete Row"
                    className="Delete-Icon"
                    onClick={() => {
                      setGridRowsMap((prev) => ({
                        ...prev,
                        [gridKey]: (prev[gridKey] || []).filter(
                          (_, idx) => idx !== rowIndex,
                        ),
                      }));
                    }}
                  />
                </div>
              </div>
            ) : null;
          }

          if (isSerialColumn) {
            return (
              <div
                style={{
                  textAlign: "center",
                  fontWeight: 500,
                  cursor: "pointer",
                  color: "#1d4ed8",
                  width: "100%",
                  paddingTop: "4px",
                }}
                onClick={() => {
                  if (gridKey === "main") openLinePopup(rowIndex);
                }}
              >
                {rowIndex + 1}
              </div>
            );
          }

          if (isCheckboxField) {
            return (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100%",
                }}
              >
                <div
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "22px",
                    height: "22px",
                    borderRadius: "7px",
                    border: "1px solid #d9e3f0",
                    background:
                      "linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)",
                    boxShadow: "inset 0 1px 2px rgba(15, 23, 42, 0.04)",
                  }}
                >
                  <input
                    type="checkbox"
                    checked={row[field] === "Y" || row[field] === true}
                    disabled={isReadOnly}
                    style={{
                      cursor: isReadOnly ? "not-allowed" : "pointer",
                      width: "14px",
                      height: "14px",
                      accentColor: "#2563eb",
                    }}
                    onChange={(e) => {
                      const checked = e.target.checked ? "Y" : "N";
                      handleCellChangeForGrid(
                        gridKey,
                        rowIndex,
                        field,
                        checked,
                      );
                    }}
                  />
                </div>
              </div>
            );
          }

          if (isDateField) {
            return (
              <div style={{ width: "100%", minWidth: 120, padding: "2px 0" }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    format="DD-MM-YYYY"
                    value={
                      row[field]
                        ? dayjs(row[field], ["YYYY-MM-DD", "DD-MM-YYYY"])
                        : dayjs()
                    }
                    disabled={isReadOnly}
                    onChange={(newValue) => {
                      handleCellChangeForGrid(
                        gridKey,
                        rowIndex,
                        field,
                        newValue ? newValue.format("YYYY-MM-DD") : "",
                      );
                    }}
                    PopperProps={{ sx: { zIndex: 14000 } }}
                    slotProps={{
                      popper: {
                        className: "purchase-order-date-picker-popper",
                      },
                      desktopPaper: {
                        className: "purchase-order-date-picker-paper",
                      },
                      mobilePaper: {
                        className: "purchase-order-date-picker-paper",
                      },
                      textField: {
                        className: "purchase-order-grid-date-control",
                        sx: { width: "100%", maxWidth: "120px" },
                        InputProps: {
                          disableUnderline: true,
                          style: {
                            height: "33px",
                            fontSize: "12px",
                            borderRadius: "4px",
                            padding: "8px 2px 8px 12px",
                            border: "1px solid #c4dbf8",
                            background:
                              "linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)",
                            color: "#16202B",
                            boxShadow: "inset 0 1px 2px rgba(15, 23, 42, 0.04)",
                          },
                        },
                      },
                    }}
                  />
                </LocalizationProvider>
              </div>
            );
          }

          const normalizedField = String(field || "").toLowerCase();
          const normalizedItemField = normalizedField.replace(/^grdcol/, "");
          const isRemarksField =
            normalizedField.includes("remark") ||
            String(c.ColHdText || "")
              .toLowerCase()
              .includes("remark");
          const isFilePathField =
            normalizedField === "filepath" ||
            normalizedField === "file_path" ||
            normalizedField.endsWith("filepath");
          const isFileNameField =
            normalizedField === "filename" ||
            normalizedField === "file_name" ||
            normalizedField.endsWith("filename");
          const isFileExtensionField =
            normalizedField === "fileextension" ||
            normalizedField === "file_extension" ||
            normalizedField.endsWith("extension") ||
            normalizedField.endsWith("ext");
          const isFileDataField =
            normalizedField === "filedata" ||
            normalizedField === "file_data" ||
            normalizedField.endsWith("filedata");

          if (normalizedItemField === "itemdetails") {
            return (
              <input
                type="text"
                value={row[field] ?? row.ItemDetails ?? ""}
                readOnly
                style={{
                  ...inputStyle,
                  cursor: isApprovedView ? "not-allowed" : "pointer",
                }}
                onClick={() => {
                  openItemDetailsPopup(
                    gridKey,
                    rowIndex,
                    field,
                    row[field] ?? row.ItemDetails ?? "",
                  );
                }}
              />
            );
          }

          if (isRemarksField) {
            return (
              <input
                type="text"
                value={row[field] ?? ""}
                readOnly
                style={{
                  ...inputStyle,
                  cursor: "pointer",
                }}
                onClick={() => {
                  openItemDetailsPopup(
                    gridKey,
                    rowIndex,
                    field,
                    row[field] ?? "",
                    c.ColHdText || c.ColHdName || c.Tbl_Col_Name || field,
                  );
                }}
              />
            );
          }

          if (
            isFilePathField ||
            isFileNameField ||
            isFileExtensionField ||
            isFileDataField
          ) {
            const resolvedValue = isFileDataField
              ? (row[field] ?? row.fileData ?? row.FileData ?? "")
              : isFileExtensionField
                ? (row[field] ??
                  row.fileExt ??
                  row.FileExtension ??
                  row.fileExtension ??
                  "")
                : isFileNameField
                  ? (row[field] ?? row.fileName ?? row.FileName ?? "")
                  : (row[field] ?? row.filePath ?? row.FilePath ?? "");

            if (isFilePathField) {
              const openFilePicker = () => {
                fileInputRefs.current[rowIndex]?.click();
              };

              const handleSelectedFile = async (selectedFile) => {
                if (!selectedFile) return;

                const base64 = await convertToBase64(selectedFile);
                const { fileName, fileNameWithoutExt, fileExtension } =
                  getFileMetaData(selectedFile);

                setGridRowsMap((prev) => {
                  const currentRows = prev[gridKey] || rows;
                  const updatedRows = [...currentRows];
                  const fileRow = {
                    ...updatedRows[rowIndex],
                    file: selectedFile,
                    filePath: fileName,
                    FilePath: fileName,
                    fileName: fileNameWithoutExt,
                    FileName: fileNameWithoutExt,
                    fileExt: fileExtension,
                    FileExtension: fileExtension,
                    fileExtension: fileExtension,
                    fileData: base64,
                    FileData: base64,
                  };

                  if (field) {
                    const f = String(field).toLowerCase();
                    if (f === "filepath" || f.endsWith("filepath")) {
                      fileRow[field] = fileName;
                    } else if (f === "filename" || f.endsWith("filename")) {
                      fileRow[field] = fileNameWithoutExt;
                    } else if (
                      f === "fileextension" ||
                      f.endsWith("extension") ||
                      f === "fileext" ||
                      f.endsWith("ext")
                    ) {
                      fileRow[field] = fileExtension;
                    } else if (f === "filedata" || f.endsWith("filedata")) {
                      fileRow[field] = base64;
                    }
                  }

                  updatedRows[rowIndex] = fileRow;
                  return { ...prev, [gridKey]: updatedRows };
                });
              };

              return (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: getGridColumnWidth(c),
                    minWidth: 50,
                    border: "1px dashed #bfdbfe",
                    borderRadius: "10px",
                    background: "linear-gradient(180deg, #f8fbff, #eef6ff)",
                    padding: "0 8px",
                    minHeight: "36px",
                    cursor: "pointer",
                    overflow: "hidden",
                  }}
                  onClick={openFilePicker}
                  onDragOver={(e) => {
                    e.preventDefault();
                    e.dataTransfer.dropEffect = "copy";
                  }}
                  onDrop={(e) => {
                    e.preventDefault();
                    const droppedFile = e.dataTransfer?.files?.[0];
                    if (droppedFile) {
                      handleSelectedFile(droppedFile);
                    }
                  }}
                >
                  <input
                    type="file"
                    ref={(el) => {
                      fileInputRefs.current[rowIndex] = el;
                    }}
                    style={{ display: "none" }}
                    onChange={async (e) => {
                      const selectedFile = e.target.files?.[0];
                      if (!selectedFile) return;

                      await handleSelectedFile(selectedFile);

                      if (e.target) e.target.value = "";
                    }}
                  />
                  <input
                    type="text"
                    value={resolvedValue}
                    placeholder="Click or Drag file"
                    readOnly
                    style={{
                      ...inputStyle,
                      width: getGridColumnWidth(c),
                      minWidth: 50,
                      cursor: "pointer",
                      color: resolvedValue ? "#17212f" : "#64748b",
                    }}
                    onClick={openFilePicker}
                  />
                </div>
              );
            }

            if (isFileDataField && resolvedValue) {
              return (
                <button
                  type="button"
                  className="Preview-Button"
                  onClick={() => openFilePreview(row, resolvedValue)}
                >
                  Preview
                </button>
              );
            }

            return (
              <input
                type="text"
                value={resolvedValue}
                readOnly
                style={{
                  ...inputStyle,
                  cursor: "default",
                  background: "#f8fafc",
                  fontFamily: isFileDataField ? "monospace" : "inherit",
                }}
              />
            );
          }

          if (isNumberField) {
            return (
              <input
                type="number"
                step={inputType === "number-decimal" ? "0.01" : "1"}
                value={row[field] ?? ""}
                readOnly={isReadOnly}
                style={{
                  ...inputStyle,
                  cursor:
                    isPopup && !isReadOnly
                      ? "pointer"
                      : isReadOnly
                        ? "not-allowed"
                        : "text",
                }}
                onChange={(e) => {
                  if (!isReadOnly) {
                    const numValue = convertValueByDataType(
                      e.target.value,
                      c.Tbl_Col_DataType,
                    );
                    handleCellChangeForGrid(gridKey, rowIndex, field, numValue);
                  }
                }}
                onClick={() => {
                  if (isPopup && !isReadOnly) {
                    handleGridPopupOpen(c, rowIndex, gridKey);
                  }
                }}
              />
            );
          }

          return (
            <input
              type="text"
              value={row[field] ?? ""}
              readOnly={isReadOnly}
              style={{
                ...inputStyle,
                cursor:
                  isPopup && !isReadOnly
                    ? "pointer"
                    : isReadOnly
                      ? "not-allowed"
                      : "text",
              }}
              onChange={(e) => {
                if (!isReadOnly) {
                  handleCellChangeForGrid(
                    gridKey,
                    rowIndex,
                    field,
                    e.target.value,
                  );
                }
              }}
              onClick={() => {
                if (isPopup && !isReadOnly) {
                  handleGridPopupOpen(c, rowIndex, gridKey);
                }
              }}
            />
          );
        },
      });
    });

    const displayColumns = [
      ...columns.filter((column) => column.field !== "__action__"),
      ...columns.filter((column) => column.field === "__action__"),
    ];

    const getDisplayColumnWidth = (column) => {
      if (column.field === "__action__") return 80;
      const columnConfig = cfg.find((c) => getGridFieldName(c) === column.field);
      return getGridColumnWidth(columnConfig || {});
    };

    const isLineIdentifierColumn = (column = {}) => {
      const names = [column.ColHdName, column.Tbl_Col_Name, column.ColHdText, getGridFieldName(column)]
        .filter(Boolean)
        .map((value) => String(value).replace(/[\s_-]/g, "").toLowerCase());
      return names.some((name) => /^(slno|serialno|lineid|lineno|baselineid)$/.test(name) || /^grdcol(slno|lineid|lineno|baselineid)$/.test(name));
    };

    const numericFields = new Set(
      cfg
        .filter((column) => {
          const inputType = getInputTypeFromDataType(column.Tbl_Col_DataType);
          return !isLineIdentifierColumn(column) && (inputType === "number-integer" || inputType === "number-decimal");
        })
        .map((column) => getGridFieldName(column))
        .filter(Boolean),
    );

    const totalRow = displayColumns.reduce((result, column) => {
      if (column.field === "__action__") result[column.field] = "Total";
      else if (numericFields.has(column.field)) {
        const total = gridRows.reduce((sum, row) => {
          const value = Number(row[column.field]);
          return sum + (Number.isFinite(value) ? value : 0);
        }, 0);
        result[column.field] = total.toFixed(2);
      }
      return result;
    }, {});

    const totalGridWidth = displayColumns.reduce(
      (sum, column) => sum + getDisplayColumnWidth(column),
      0,
    );
    const startColumnResize = (field, event) => {
      if (!field || field === "__action__") return;

      const currentWidth = Number(
        gridColumnWidths[field] ??
          displayColumns.find((c) => c.field === field)?.width ??
          150,
      );

      resizeStateRef.current = {
        field,
        startX: event.clientX,
        startWidth: currentWidth,
      };
    };

    return (
      <div
        className="purchase-order-grid-scroll"
        style={{ width: "100%", overflowX: "auto", marginTop: "6px" }}
      >
        <div style={{ width: "100%", minWidth: `${totalGridWidth}px` }}>
          <table
            className="purchase-order-grid-table"
            style={{
              width: "100%",
              minWidth: `${totalGridWidth}px`,
              borderCollapse: "separate",
              borderSpacing: 0,
              border: "1px solid #dfe6ee",
              borderRadius: "6px 6px 0 0",
              background: "linear-gradient(180deg, #ffffff 0%, #f9fbff 100%)",
              boxShadow: "0 8px 20px rgba(15, 23, 42, 0.05)",
            }}
          >
            <colgroup>
              {displayColumns.map((column) => (
                <col key={column.field} style={{ width: `${getDisplayColumnWidth(column)}px` }} />
              ))}
            </colgroup>
            <thead>
              <tr>
                {displayColumns.map((column) => (
                  <th
                    key={column.field}
                    className={
                      column.field === "__action__"
                        ? "purchase-order-action-cell"
                        : ""
                    }
                    style={{
                      position: "relative",
                      width: getDisplayColumnWidth(column),
                      minWidth: getDisplayColumnWidth(column),
                      background: "linear-gradient(135deg, #88aaf3, #3e69df)",
                      color: "#ffffff",
                      fontWeight: 700,
                      fontSize: "12px",
                      borderRight: "1px solid #dfe6ee",
                      padding: "5px 10px",
                      textAlign: "left",
                      height: "35px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "35px",
                        width: "100%",
                      }}
                    >
                      {column.headerName}
                    </div>
                    {column.field !== "__action__" && (
                      <div
                        onMouseDown={(event) =>
                          startColumnResize(column.field, event)
                        }
                        style={{
                          position: "absolute",
                          top: 0,
                          right: 0,
                          width: "8px",
                          height: "100%",
                          cursor: "col-resize",
                          background: "transparent",
                          zIndex: 2,
                        }}
                      />
                    )}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {gridRows.map((row) => (
                <tr
                  key={row.id}
                  style={{ background: "rgba(255,255,255,0.5)" }}
                >
                  {displayColumns.map((column) => {
                    const cellContent =
                      typeof column.renderCell === "function"
                        ? column.renderCell({
                            row,
                            id: row.id,
                            field: column.field,
                            value: row[column.field],
                          })
                        : (row[column.field] ?? "");

                    return (
                      <td
                        key={`${row.id}-${column.field}`}
                        className={
                          column.field === "__action__"
                            ? "purchase-order-action-cell"
                            : ""
                        }
                        style={{
                          borderRight: "1px solid #edf1f5",
                          borderTop: "1px solid #edf1f5",
                          padding: "5px 10px",
                          fontSize: "10px",
                          verticalAlign: "middle",
                          background: "rgba(255,255,255,0.5)",
                          whiteSpace: "normal",
                        }}
                      >
                        {cellContent}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
            {numericFields.size > 0 && (
              <tfoot><tr className="purchase-order-grid-total-row">
                {displayColumns.map((column) => {
                  const isTotalLabel = column.field === "__action__";
                  const isNumericTotal = numericFields.has(column.field);
                  return <td key={`total-${column.field}`} className={`${isTotalLabel ? "purchase-order-grid-total-label purchase-order-action-cell" : ""} ${isNumericTotal ? "purchase-order-grid-total-value" : ""}`} style={{ width: getDisplayColumnWidth(column), minWidth: getDisplayColumnWidth(column) }}>{totalRow[column.field] ?? ""}</td>;
                })}
              </tr></tfoot>
            )}
          </table>
        </div>
      </div>
    );
  };

  const resetAttachments = () => {
    setAttachmentData([emptyRow()]);
    fileInputRefs.current = []; // 🔥 clear file input refs safely
  };

  const resetForm = () => {
    // Reset header data
    const d = {};

    cfg.forEach((r) => {
      if (!r.ColHdName) return;

      let value = "";
      if (r._QueryValue !== null && r._QueryValue !== undefined) {
        value = r._QueryValue;
      } else if (r.DefaultValue) {
        value = r.DefaultValue.replace(/[()']/g, "");
      }

      if (r.ColHdName === "CompCode") value = CompanyCode;
      if (r.ColHdName === "CompName") value = CompanyName;
      if (r.ColHdName === "Location") value = CompanyLocation;
      if (r.ColHdName === "DocStatus" && !value) value = "OPEN";
      if (r.ColType === "DatePicker") value = moment().format("YYYY-MM-DD");
      if (r.ColHdName === "DocNum") value = "";

      d[r.ColHdName] = value;
    });

    setData(d);

    // Reset grid rows to one blank row
    const resetRows = {};
    gridTabs.forEach((tabName) => {
      resetRows[tabName] = [{ _rowCreated: false }];
    });

    setGridRowsMap(resetRows);
    setRowData([{ FreightTaxable: "", _rowCreated: false }]);
    resetAttachments();

    return d;
  };

  useEffect(() => {
    const handleMouseMove = (event) => {
      const { field, startX, startWidth } = resizeStateRef.current;
      if (!field) return;

      const delta = event.clientX - startX;
      const nextWidth = Math.max(80, startWidth + delta);

      const matchedColumn = (
        gridConfigMap[activeGridTab || gridTabs[0] || "main"] || []
      ).find((c) => getGridFieldName(c) === field || c?.Tbl_Col_Name === field);

      setGridColumnWidths((prev) => ({
        ...prev,
        [field]: nextWidth,
        ...(matchedColumn?.Tbl_Col_Name && matchedColumn.Tbl_Col_Name !== field
          ? { [matchedColumn.Tbl_Col_Name]: nextWidth }
          : {}),
      }));
    };

    const handleMouseUp = () => {
      resizeStateRef.current = { field: null, startX: 0, startWidth: 0 };
    };

    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseup", handleMouseUp);

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    };
  }, []);

  useEffect(() => {
    setAttachmentData([emptyRow()]);
  }, []);

  useEffect(() => {
    fetch(`${API}/api/attachment-doctypes-payment`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
    })
      .then((res) => res.json())
      .then(setDocTypes)
      .catch(console.error);
  }, []);

  const convertToBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () =>
        resolve(String(reader.result || "").split(",")[1] || "");
      reader.onerror = reject;
    });

  const getFileMetaData = (file) => {
    const fileName = file?.name || "";
    const fileNameWithoutExt = fileName.replace(/\.[^/.]+$/, "") || fileName;
    const fileExtension = fileName.includes(".")
      ? fileName.slice(fileName.lastIndexOf("."))
      : "";

    return {
      fileName,
      fileNameWithoutExt,
      fileExtension,
    };
  };

  const fileDataToBase64 = (value) => {
    if (!value) return "";

    const bytesToBase64 = (byteValues) => {
      let binary = "";
      const chunkSize = 0x8000;
      for (let index = 0; index < byteValues.length; index += chunkSize) {
        binary += String.fromCharCode(
          ...byteValues.slice(index, index + chunkSize),
        );
      }

      const textValue = new TextDecoder()
        .decode(new Uint8Array(byteValues))
        .trim();
      if (
        textValue &&
        /^[A-Za-z0-9+/]+={0,2}$/.test(textValue.replace(/\s/g, "")) &&
        textValue.replace(/\s/g, "").length % 4 === 0
      ) {
        return textValue.replace(/\s/g, "");
      }

      return window.btoa(binary);
    };

    if (typeof value === "string") {
      const normalizedValue = value.trim();
      if (!normalizedValue) return "";
      if (normalizedValue.startsWith("data:")) return normalizedValue;

      if (/^0x[0-9a-f]+$/i.test(normalizedValue)) {
        const hex = normalizedValue.slice(2);
        const bytes = [];
        for (let index = 0; index < hex.length; index += 2) {
          bytes.push(parseInt(hex.slice(index, index + 2), 16));
        }
        return bytesToBase64(bytes);
      }

      return normalizedValue.replace(/^base64,/, "").replace(/\s/g, "");
    }

    const byteValues = Array.isArray(value)
      ? value
      : Array.isArray(value.data)
        ? value.data
        : null;

    if (byteValues) {
      return bytesToBase64(byteValues);
    }

    return "";
  };

  const openFilePreview = (row, fileData = "") => {
    const rawFileData = fileData || row?.fileData || row?.FileData || "";
    const base64 = fileDataToBase64(rawFileData);
    if (!base64) {
      toast.info("No file data available for preview");
      return;
    }

    const extension = String(
      row?.fileExt || row?.FileExtension || row?.fileExtension || "",
    )
      .toLowerCase()
      .replace(/^\./, "");
    const mimeTypes = {
      pdf: "application/pdf",
      jpg: "image/jpeg",
      jpeg: "image/jpeg",
      png: "image/png",
      gif: "image/gif",
      webp: "image/webp",
      bmp: "image/bmp",
      svg: "image/svg+xml",
      txt: "text/plain",
      csv: "text/csv",
      mp4: "video/mp4",
      webm: "video/webm",
      mp3: "audio/mpeg",
      wav: "audio/wav",
    };
    const type = mimeTypes[extension] || "application/octet-stream";
    const src = String(base64).startsWith("data:")
      ? base64
      : `data:${type};base64,${base64}`;

    setFilePreview({
      open: true,
      name:
        row?.fileName ||
        row?.FileName ||
        row?.filePath ||
        row?.FilePath ||
        "Attachment",
      src,
      type,
    });
  };

  const handleSave = async (saveMode = "insert") => {
    if (isApprovedView) return;

    const isUpdateSave = saveMode === "update";
    const updateDocEntry = Number(data?.DocEntry || form.findDocEntry);

    if (isUpdateSave && !Number.isInteger(updateDocEntry)) {
      toast.error("Please find a AP Invoice before updating.");
      return;
    }

    try {
      // Use display names (ColHdName) for getting ordered columns
      const headerColumns = getOrderedHeaderColumns();

      // Use database names (Tbl_Col_Name) for API payload
      const headerColumnsForDB = getOrderedHeaderColumnsForDB();

      const header = {};
      const headerFieldConfigMap = {};
      const displayToDBMap = {}; // Map from ColHdName to Tbl_Col_Name

      (allCfg.length ? allCfg : cfg || []).forEach((column) => {
        const displayField = column?.ColHdName;
        const dbField = column?.Tbl_Col_Name;
        // Only map fields with non-blank Tbl_Col_Name to backend
        if (displayField && dbField && dbField.trim() !== "") {
          displayToDBMap[displayField] = dbField;
          headerFieldConfigMap[dbField] = column;
        }
      });

      const requiredMetaFields = {
        FrmName: "FrmAPInvoice_MBC",
        ObjectCode: data.ObjectCode || "PCH",
        UserID: UserID || "",
        PCName: "superinfolabs_c",
        DocNum: "#DocNum",
        DocEntry: "#DOCENTRY",
      };

      // Keep the real DocNum on screen for display, but send the placeholder token only to backend save APIs.
      const displayDocNum = data.DocNum ?? "";

      Object.entries(requiredMetaFields).forEach(([field, value]) => {
        const fieldName = String(field || "").trim();
        if (!fieldName) return;

        const exists = headerColumnsForDB.some(
          (column) =>
            String(column || "").toLowerCase() === fieldName.toLowerCase(),
        );

        if (!exists) {
          headerColumnsForDB.push(fieldName);
        }

        header[fieldName] = value;
      });

      headerColumnsForDB.forEach((dbColumn) => {
        if (dbColumn === "DocNum") {
          header[dbColumn] = "#DocNum";
          return;
        }

        if (dbColumn === "DocNum" && displayDocNum) {
          // leave the actual value only in form state; backend still receives the special placeholder token
        }

        if (
          dbColumn === "DocEntry" ||
          /DocEntry$/i.test(String(dbColumn || ""))
        ) {
          header[dbColumn] = "#DOCENTRY";

          return;
        }

        if (dbColumn === "FrmName") {
          header[dbColumn] = "FrmAPInvoice_MBC";
          return;
        }

        if (dbColumn === "ObjectCode") {
          header[dbColumn] = data.ObjectCode || "PCH";
          return;
        }

        if (dbColumn === "UserID") {
          header[dbColumn] = UserID || "";
          return;
        }

        if (dbColumn === "PCName") {
          header[dbColumn] = "superinfolabs_c";
          return;
        }

        let displayField = dbColumn;
        for (const [dField, tField] of Object.entries(displayToDBMap)) {
          if (tField === dbColumn) {
            displayField = dField;
            break;
          }
        }

        const columnCfg = headerFieldConfigMap[dbColumn];
        const fieldDataType =
          columnCfg?.ColDataType || columnCfg?.Tbl_Col_DataType;
        const rawValue = data[displayField];

        header[dbColumn] = normalizeInsertValue(rawValue, fieldDataType);
      });

      const masterTableName =
        sanitizeTableName(
          allCfg.find((column) =>
            sanitizeTableName(column?.TableName || column?.TblName),
          )?.TableName ||
            allCfg.find((column) =>
              sanitizeTableName(column?.TableName || column?.TblName),
            )?.TblName,
        ) || "OPOR";

      const gridTabNames =
        Array.isArray(gridTabs) && gridTabs.length
          ? gridTabs
          : Object.keys(allGridConfigMap || {});

      const detailTableSlotOrder = [1, 2, 3, 5, 6, 7, 8];
      const detailTableNames = Array(8).fill("");
      const details = {};
      const detailColumns = {};

      gridTabNames.forEach((gridName, index) => {
        const gridConfig =
          allGridConfigMap[gridName] || gridConfigMap[gridName] || [];
        const isContentsGrid = /content/i.test(String(gridName || ""));

        if (!Array.isArray(gridConfig) || !gridConfig.length) {
          return;
        }

        const tableName =
          sanitizeTableName(
            gridConfig.find((column) => column?.TableName || column?.TblName)
              ?.TableName ||
              gridConfig.find((column) => column?.TableName || column?.TblName)
                ?.TblName ||
              gridName,
          ) || "PDN1";

        const assignedSlot = detailTableSlotOrder[index] || null;
        if (assignedSlot && !detailTableNames[assignedSlot - 1]) {
          detailTableNames[assignedSlot - 1] = tableName;
        }

        const columnsForDB = [];
        const seenColumns = new Set();
        const fieldConfigMap = {};
        const displayToDBMap = {};

        gridConfig.forEach((column) => {
          const displayField = column?.ColHdName;
          const dbField = column?.Tbl_Col_Name;

          if (displayField && dbField && dbField.trim() !== "") {
            displayToDBMap[displayField] = dbField;
            fieldConfigMap[dbField] = column;
          } else if (displayField) {
            displayToDBMap[displayField] = displayField;
            fieldConfigMap[displayField] = column;
          } else if (dbField) {
            fieldConfigMap[dbField] = column;
          }
        });

        gridConfig.forEach((column) => {
          const dbField = column?.Tbl_Col_Name;
          const displayField = column?.ColHdName;
          const candidate = dbField && dbField.trim() ? dbField : displayField;

          if (!candidate) return;
          if (
            candidate === "_rowCreated" ||
            candidate === "isExisting" ||
            candidate === "_rowId" ||
            candidate === "file"
          ) {
            return;
          }

          if (!seenColumns.has(candidate)) {
            seenColumns.add(candidate);
            columnsForDB.push(candidate);
          }
        });

        if (!seenColumns.has("LineID")) {
          columnsForDB.push("LineID");
        }

        const gridRows = (gridRowsMap[gridName] || []).map((row) =>
          ensureGridDateDefaults(row || {}, gridConfig),
        );

        const validRows = gridRows
          .filter((row) => {
            if (!row) return false;

            return Object.keys(row).some((key) => {
              if (
                key === "_rowCreated" ||
                key === "isExisting" ||
                key === "_rowId" ||
                key === "file"
              ) {
                return false;
              }

              const value = row[key];
              return (
                value !== null &&
                value !== undefined &&
                String(value).trim() !== ""
              );
            });
          })
          .map((row, rowIndex) => {
            const orderedRow = {};

            columnsForDB.forEach((dbColumn) => {
              const isDocEntryColumn = /DocEntry$/i.test(
                String(dbColumn || ""),
              );
              const isLineIdColumn = /LineID$/i.test(String(dbColumn || ""));
              const normalizedDbColumn = String(dbColumn || "")
                .replace(/[_\s]/g, "")
                .toLowerCase();

              if (isContentsGrid && normalizedDbColumn === "basecompcode") {
                orderedRow[dbColumn] = data.CompCode || CompanyCode || "";
                return;
              }

              if (isContentsGrid && normalizedDbColumn === "baselocation") {
                orderedRow[dbColumn] = data.Location || CompanyLocation || "";
                return;
              }

              if (isContentsGrid && normalizedDbColumn === "baseobjectcode") {
                orderedRow[dbColumn] = data.ObjectCode || "POS";
                return;
              }

              if (isContentsGrid && normalizedDbColumn === "baseseries") {
                orderedRow[dbColumn] = data.Series || "";
                return;
              }

              if (isContentsGrid && normalizedDbColumn === "basedocnum") {
                orderedRow[dbColumn] = data.DocNum || "";
                return;
              }

              if (isContentsGrid && normalizedDbColumn === "baseslno") {
                orderedRow[dbColumn] = rowIndex + 1;
                return;
              }

              if (isLineIdColumn) {
                orderedRow[dbColumn] = rowIndex + 1;
                return;
              }

              if (isDocEntryColumn) {
                orderedRow[dbColumn] = "#DOCENTRY";
                return;
              }

              let displayField = dbColumn;
              for (const [dField, tField] of Object.entries(displayToDBMap)) {
                if (tField === dbColumn) {
                  displayField = dField;
                  break;
                }
              }

              const columnCfg = fieldConfigMap[dbColumn];
              const fieldDataType =
                columnCfg?.ColDataType || columnCfg?.Tbl_Col_DataType;
              const attachmentValue =
                normalizedDbColumn === "filepath"
                  ? (row[displayField] ?? row.filePath ?? row.FilePath ?? "")
                  : normalizedDbColumn === "filename"
                    ? (row[displayField] ?? row.fileName ?? row.FileName ?? "")
                    : normalizedDbColumn === "fileextension"
                      ? (row[displayField] ??
                        row.fileExt ??
                        row.fileExtension ??
                        row.FileExtension ??
                        "")
                      : normalizedDbColumn === "filedata"
                        ? (row[displayField] ??
                          row.fileData ??
                          row.FileData ??
                          "")
                        : row[displayField];

              orderedRow[dbColumn] = normalizeInsertValue(
                attachmentValue,
                fieldDataType,
              );
            });

            if (
              !Object.keys(orderedRow).some((key) =>
                /LineID$/i.test(String(key || "")),
              )
            ) {
              orderedRow.LineID = rowIndex + 1;
            }

            return orderedRow;
          });

        details[tableName] = validRows;
        detailColumns[tableName] = columnsForDB;
      });

      const payload = {
        MTBLName: masterTableName,

        DTBLNames: detailTableNames,
        header,

        headerColumns: headerColumnsForDB,

        details,

        detailColumns,

        FrmName: "FrmAPInvoice_MBC",

        ObjectCode: data.ObjectCode || "PCH",

        UserID: UserID,

        PCName: "superinfolabs_c",
      };

      if (isUpdateSave) {
        payload.DocEntry = updateDocEntry;
      }

      const res = await axios.post(
        `${API}${isUpdateSave ? "/api/ap-invoice-update" : "/api/ap-invoice-save"}`,
        payload,
      );

      if (res.data.success) {
        const successMessage = res.data.message || "AP Invoice saved successfully!";

        toast.success(successMessage);

        setPageMode("ADD");

        setForm({
          findDisplay: "",
          findDocEntry: null,
        });

        /*
         * Reset form
         */
        if (isUpdateSave) {
          setIsUpdateMode(true);
          return;
        }

        const resetData = resetForm();

        /*
         * Generate next document number
         */
        if (resetData?.Series) {
          fetchNextDocNum(resetData.Series, resetData.DueDate);
        }
      }
    } catch (err) {
      console.error("AP Invoice save error:", err);

      toast.error(err?.response?.data?.message || "Save error");
    }
  };

  const handleFindChange = (e) => {
    const { name, value } = e.target;
    setFindFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
    setShowFindTable(false);
    setPageIndex(0);
  };

  const handleIgnoreDateToggle = (e) => {
    const checked = e.target.checked;

    setFindFilters((prev) => ({
      ...prev,
      ignoreDate: checked,
      fromDate: checked
        ? "01-01-1900"
        : formatDate(dayjs().subtract(1, "month")),
      toDate: formatDate(dayjs()),
    }));
    setShowFindTable(false);
    setPageIndex(0);
  };

  const openFindPopup = useCallback(async () => {
    setFindPopup({ open: false, data: [], loading: true });
    setShowFindTable(false);

    try {
      const res = await axios.post(`${API}/api/find-Form-Design`, {
        CompanyCode: CompanyCode,
        Location: CompanyLocation,
        FrmName: "FrmAPInvoice_MBC",
        ignoreDate: findFilters.ignoreDate,
        fromDate: findFilters.fromDate,
        docMode: findFilters.docMode,
        docStatus: findFilters.docStatus,
        toDate: findFilters.toDate,
      });

      setFindPopup({
        open: false,
        data: res.data,
        loading: false,
      });
      setFindResults(res.data || []);
      setShowFindTable(true);
      setSearchTerm("");
      setPageIndex(0);
    } catch (err) {
      console.error(err);
      setFindPopup((p) => ({ ...p, loading: false }));
    }
  }, [CompanyCode, CompanyLocation, findFilters]);

  const getColor = (value) => {
    if (!value) return "#64748b";

    const key = value.toUpperCase();

    // ✅ Return mapped color
    if (getStatusStyle[key]) {
      return getStatusStyle[key];
    }

    // 🔁 fallback (for new locations)
    const fallbackColors = [
      "#2563eb",
      "#16a34a",
      "#dc2626",
      "#d97706",
      "#7c3aed",
      "#0891b2",
    ];

    let hash = 0;
    for (let i = 0; i < value.length; i++) {
      hash = value.charCodeAt(i) + ((hash << 5) - hash);
    }

    return fallbackColors[Math.abs(hash) % fallbackColors.length];
  };

  const getRowBgColor = (value) => {
    if (!value) return "transparent";

    const key = value.toUpperCase();

    const rowColors = {
      DRAFT: "#dbeafe", // light blue
      APPROVED: "#dcfce7", // light green
      REJECTED: "#fee2e2", // light red
      RELEASED: "#fce7f3", // light pink
    };

    return rowColors[key] || "#f8fafc"; // fallback light gray
  };

  useEffect(() => {
    if (autoLoad && !loading) {
      openFindPopup();
    }
  }, [autoLoad, loading, openFindPopup]);

  const loadSalesOrder = async (
    docEntry,
    companyCode = CompanyCode,
    location = CompanyLocation,
    approvedView = false,
  ) => {
    try {
      setLoading(true);
      const res = await axios.post(`${API}/api/get-Form-Design`, {
        DocEntry: docEntry,
        CompanyCode: companyCode,
        Location: location,
      });

      const { header = {}, details = {} } = res.data || {};

      // Set header data
      const headerData = {};
      (allCfg.length ? allCfg : cfg).forEach((c) => {
        const displayField = c.ColHdName;
        const dbField = c.Tbl_Col_Name;

        if (
          displayField &&
          (header[displayField] !== undefined || header[dbField] !== undefined)
        ) {
          let value = header[displayField] ?? header[dbField];
          if (c.ColHdName === "DocNum") {
            value = padDocNum(value);
          }
          headerData[displayField] = value;
        }
      });

      if (!headerData.CompCode) headerData.CompCode = companyCode;
      if (!headerData.CompName) headerData.CompName = CompanyName;
      if (!headerData.Location) headerData.Location = location;
      setData(headerData);

      const dropdownConfigs = (allCfg.length ? allCfg : cfg).filter(
        (column) => column.ColType === "DropdownBox",
      );
      const dropdownOptions = await Promise.all(
        dropdownConfigs.map(async (column) => {
          try {
            const optionsResponse = await axios.post(
              `${API}/api/get-Form-Design-control-options`,
              {
                fieldName: column.ColHdName,
                formData: {
                  ...headerData,
                  CompCode: companyCode,
                  Location: location,
                  UserID,
                  BPCode: headerData.BPCode || "",
                  BPLocation: headerData.BillToLocation || "",
                  CompLocation: location,
                  RCM: headerData.RCM || "N",
                },
              },
            );

            return [
              column.ColHdName,
              Array.isArray(optionsResponse.data) ? optionsResponse.data : [],
            ];
          } catch (error) {
            console.error(`${column.ColHdName} options error:`, error);
            return [column.ColHdName, []];
          }
        }),
      );

      const optionsByField = Object.fromEntries(dropdownOptions);
      setAllCfg((prev) =>
        prev.map((column) =>
          optionsByField[column.ColHdName]
            ? { ...column, _QueryTable: optionsByField[column.ColHdName] }
            : column,
        ),
      );
      setCfg((prev) =>
        prev.map((column) =>
          optionsByField[column.ColHdName]
            ? { ...column, _QueryTable: optionsByField[column.ColHdName] }
            : column,
        ),
      );

      const loadedRowsMap = {};
      gridTabs.forEach((gridName) => {
        const gridConfig =
          allGridConfigMap[gridName] || gridConfigMap[gridName] || [];
        const tableName = sanitizeTableName(
          gridConfig.find((column) => column?.TableName || column?.TblName)
            ?.TableName ||
            gridConfig.find((column) => column?.TableName || column?.TblName)
              ?.TblName,
        );
        const sourceRows = details[tableName] || [];

        const formattedRows = sourceRows.map((sourceRow, rowIndex) => {
          const row = {
            ...sourceRow,
            _rowId: `${gridName}-${docEntry}-${rowIndex}`,
            _rowCreated: true,
            isExisting: true,
          };

          gridConfig.forEach((column) => {
            const displayField = column?.ColHdName;
            const dbField = column?.Tbl_Col_Name;
            if (!displayField || row[displayField] !== undefined || !dbField)
              return;
            if (sourceRow[dbField] !== undefined) {
              row[displayField] = sourceRow[dbField];
            }
          });

          return ensureGridDateDefaults(row, gridConfig);
        });

        loadedRowsMap[gridName] = formattedRows;
      });

      setGridRowsMap(loadedRowsMap);
      const firstGridName = gridTabs[0];
      setRowData(loadedRowsMap[firstGridName] || []);
      setGridCfg(gridConfigMap[activeGridTab || firstGridName] || []);
      setAttachmentData([emptyRow()]);

      // Switch to ADD tab and set update mode
      setPageMode("ADD");
      setIsUpdateMode(true);
      setIsApprovedView(approvedView);
    } catch (err) {
      toast.error("Load Purchase Order error:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleFindSelect = (row) => {
    const approvedView = row.DocMode === "APPROVED";
    setForm((prev) => ({
      ...prev,
      findDisplay: `${row.DocNum} | ${dayjs(row.DocDate).format("DD-MM-YYYY")}`,
      findDocEntry: row.DocEntry,
    }));

    setFindPopup((prev) => ({ ...prev, open: false, loading: false }));

    const rowCompanyCode = row.CompCode || row.CompanyCode || CompanyCode;
    const rowLocation = row.Location || CompanyLocation;
    loadSalesOrder(row.DocEntry, rowCompanyCode, rowLocation, approvedView);
  };

  const handleUpdate = () => handleSave("update");

  return (
    <div>
      <ToastContainer
        className="purchase-order-toast-container"
        position="bottom-left"
        autoClose={5000}
        closeButton
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
      />

      {loading && (
        <div className="loading-overlay">
          <div className="loading-box">
            <ClipLoader size={30} />
            <p className="loading-box-text">Loading, please wait...</p>
          </div>
        </div>
      )}

      {purchaseOrderHeaderTarget && createPortal(
          <div className="Form-Design-section-tabs">
            <div className="Form-Design-section-tabs-bar">
              <button
                type="button"
                className={`Form-Design-section-tabs-button mode-find ${pageMode === "FIND" ? "active" : ""}`}
                onClick={() => setPageMode("FIND")}
              >
                <TravelExploreIcon className="Form-Design-mode-icon" />
                FIND
              </button>

              <button
                type="button"
                className={`Form-Design-section-tabs-button ${isUpdateMode ? "mode-update" : "mode-add"} ${pageMode === "ADD" ? "active" : ""}`}
                onClick={() => {
                  setPageMode("ADD");
                }}
              >
                {isUpdateMode ? (
                  <SystemUpdateAltIcon className="Form-Design-mode-icon" />
                ) : (
                  <AddCircleOutlineIcon className="Form-Design-mode-icon" />
                )}
                {isUpdateMode ? "UPDATE" : "ADD"}
              </button>
            </div>
          </div>,
          purchaseOrderHeaderTarget,
        )}

      {!loading && pageMode === "ADD" && (
        <div className="Form-Design-form">
            
          <div className="Form-Design-header">
            {/* HEADER */}
            <div className="Form-Design-header-row">
              <div className="Form-Design-header-panel">{renderGroup(HeaderLeft)}</div>

              <div className="Form-Design-header-panel">{renderGroup(HeaderRight)}</div>
            </div>

            {(Object.keys(HeaderLeft2).length > 0 ||
              Object.keys(HeaderRight2).length > 0) && (
              <div className="Form-Design-header-row">
                <div className="Form-Design-header-panel">
                  {renderGroup(HeaderLeft2)}
                </div>

                <div className="Form-Design-header-panel">
                  {renderGroup(HeaderRight2)}
                </div>
              </div>
            )}
          </div>

          <div className="Form-Design-body">
            <div className="Form-Design-Grid-Tabs">
              <div className="Form-Design-Grid-Tab-Bar">
                {gridTabs.map((item) => (
                  <button
                    key={item}
                    type="button"
                    className={`Form-Design-Grid-Tab ${
                      activeGridTab === item ? "active" : ""
                    }`}
                    onClick={() => {
                      setActiveGridTab(item);

                      // Update the currently selected grid config
                      setGridCfg(gridConfigMap[item] || []);

                      // Update currently selected grid rows
                      setRowData(
                        gridRowsMap[item] || [
                          {
                            _rowCreated: false,
                          },
                        ],
                      );
                    }}
                  >
                    {item}
                  </button>
                ))}

                <button
                  type="button"
                  className="Form-Design-Add-Line-Button"
                  title="Add line"
                  onClick={() => {
                    const currentRows = gridRowsMap[activeGridTab] || [];
                    setGridRowsMap((prev) => ({
                      ...prev,
                      [activeGridTab]: [
                        ...currentRows,
                        createDefaultGridRow(
                          gridConfigMap[activeGridTab] || [],
                        ),
                      ],
                    }));
                  }}
                  disabled={!activeGridTab}
                >
                  <AddCircleOutlineIcon fontSize="small" />
                  Add Line
                </button>
              </div>

              <div
                className="Form-Design-Grid-Tab-content"
                style={{ padding: "0 10px 10px 10px" }}
              >
                {activeGridTab &&
                  renderGridSection(
                    activeGridTab,
                    gridConfigMap[activeGridTab] || [],
                    gridRowsMap[activeGridTab] || [
                      {
                        _rowCreated: false,
                      },
                    ],
                    activeGridTab,
                  )}

                {!activeGridTab && !gridTabs.length && (
                  <div className="react-grid-wrapper">
                    <p>No grid tabs available.</p>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* FOOTER */}
          <div className="Form-Design-summary-row">
            <div className="Form-Design-summary-panel">{renderGroup(FooterLeft)}</div>

            <div className="Form-Design-summary-panel">{renderGroup(FooterRight)}</div>
          </div>

          <div className="Form-Design-action-bar">
            <div className="Form-Design-action-spacer" aria-hidden="true" />
            <div className="Form-Design-action-group">
            {!isApprovedView && (
              <button
                type="button"
                className={`Form-Design-action-button Form-Design-save-button ${isUpdateMode ? "is-update" : ""}`}
                onClick={isUpdateMode ? handleUpdate : handleSave}
              >
                <SaveIcon className="Form-Design-action-icon" />
                {isUpdateMode ? "Update" : "Insert"}
              </button>
            )}
            <button
              type="button"
              className="Form-Design-action-button Form-Design-cancel-button"
              onClick={() => {
                setIsUpdateMode(false);
                setIsApprovedView(false);
                resetForm();
                setForm({ findDisplay: "", findDocEntry: null });
              }}
            >
              <CloseIcon className="Form-Design-action-icon" />
              Cancel
            </button>
            </div>
          </div>
        </div>
      )}

      {!loading && pageMode === "FIND" && (
        <div className="purchase-order-find-mode">
          <div className="purchase-order-find-filter-header">
            {/* RIGHT PANEL */}
            <div className="purchase-order-find-panel">
              <div className="purchase-order-find-row">
                <div className="purchase-order-find-field">
                  <select
                    name="docMode"
                    value={findFilters.docMode}
                    onChange={handleFindChange}
                    className="Select-Field purchase-order-find-select"
                  >
                    <option value=""></option>
                    <option value="DRAFT">DRAFT</option>
                    <option value="RELEASED">RELEASED</option>
                    <option value="APPROVED">APPROVED</option>
                  </select>
                  <label className={findFilters.docMode ? "filled" : ""}>
                    Doc Mode
                  </label>
                </div>

                <div className="purchase-order-find-field">
                  <select
                    name="docStatus"
                    value={findFilters.docStatus}
                    onChange={handleFindChange}
                    className="Select-Field purchase-order-find-select"
                  >
                    <option value=""></option>
                    <option value="OPEN">OPEN</option>
                    <option value="CANCELED">CANCELED</option>
                    <option value="CLOSED">CLOSED</option>
                  </select>
                  <label className={findFilters.docStatus ? "filled" : ""}>
                    Status
                  </label>
                </div>
              </div>

              <div className=" purchase-order-find-row">
                <div className="purchase-order-find-date-field">
                  <DateField
                    label="From Date"
                    name="fromDate"
                    value={findFilters.fromDate}
                    onChange={handleFindChange}
                    size="sm"
                    disabled={findFilters.ignoreDate}
                    prefix="opp-"
                  />
                </div>

                <div className="purchase-order-find-date-field">
                  <DateField
                    label="To Date"
                    name="toDate"
                    value={findFilters.toDate}
                    onChange={handleFindChange}
                    size="sm"
                    disabled={findFilters.ignoreDate}
                    prefix="opp-"
                  />
                </div>
              </div>

              <div className="Footer-Content" style={{ display: "flex" }}>
                <div className="row">
                  <label
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      color: "var(--sidebar-text)",
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={findFilters.ignoreDate}
                      onChange={handleIgnoreDateToggle}
                      className=""
                    />
                    Ignore Date Filter
                  </label>
                </div>

                <div
                  className="Submit-Button-Container"
                  style={{ margin: "8px 10px" }}
                >
                  <button
                    type="button"
                    className="purchase-order-footer-button purchase-order-display-button"
                    onClick={openFindPopup}
                    disabled={
                      findFilters.ignoreDate
                        ? false
                        : !findFilters.fromDate || !findFilters.toDate
                    }
                  >
                    <VisibilityIcon className="purchase-order-footer-button-icon" />
                    Display
                  </button>
                </div>
              </div>
            </div>
          </div>

          {showFindTable && (
            <>
              <div className="purchase-order-find-search">
                <input
                  className="purchase-order-find-search-input"
                  placeholder="Search..."
                  aria-label="Search purchase orders"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                <SearchIcon className="purchase-order-find-search-icon" />
              </div>
              <div className="Table-Container">
                <table className="Table-Content">
                  <thead>
                    <tr>
                      <th>Mode</th>
                      <th>DocEntry</th>
                      <th>Customer</th>
                      <th>GL Name</th>
                      <th>Series</th>
                      <th>DocNum</th>
                      <th>DocDate</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentPageRows.map((row) => (
                      <tr
                        key={row.DocEntry}
                        onClick={() => handleFindSelect(row)}
                        style={{
                          cursor:
                            row.DocMode === "APPROVED"
                              ? "not-allowed"
                              : "pointer",
                          background: getRowBgColor(row.DocMode),
                          transition: "0.3s ease",
                        }}
                      >
                        <td>
                          <span
                            style={{
                              padding: "4px 10px",
                              borderRadius: "4px",
                              color: "#fff",
                              fontSize: "11px",
                              fontWeight: "600",
                              background: getColor(row.DocMode),
                              display: "inline-block",
                              textAlign: "center",
                              minWidth: "80px",
                            }}
                          >
                            {row.DocMode}
                          </span>
                        </td>
                        <td>{row.DocEntry}</td>
                        <td>{row.BPName}</td>
                        <td>{row.GLName}</td>
                        <td>{row.Series}</td>
                        <td>{row.DocNum}</td>
                        <td>
                          {row.DocDate
                            ? dayjs(row.DocDate).format("DD-MM-YYYY")
                            : ""}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div className="Pagination">
                  <button
                    onClick={() => previousPage()}
                    disabled={!canPreviousPage}
                    className="Pagination-Button"
                  >
                    Previous
                  </button>

                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <span className="Pagination-Center">
                      Page {pageIndex + 1} of {pageCount || 1}
                    </span>
                    <select
                      aria-label="Details per page"
                      value={findPageSize}
                      onChange={handleFindPageSizeChange}
                      className="Select-Field"
                    >
                      {[10, 20, 50, 100].map((size) => (
                        <option key={size} value={size}>
                          {size}
                        </option>
                      ))}
                    </select>
                  </span>
                  <button
                    onClick={() => nextPage()}
                    disabled={!canNextPage}
                    className="Pagination-Button"
                  >
                    Next
                  </button>
                </div>
              </div>
            </>
          )}
        </div>
      )}

      <div className="All-Popup-Container">

        {popup.open && (
          <div
            className="Value-Popup-Container"
            onClick={() => setPopup({ ...popup, open: false })}
          >
            <div
              className="Value-Popup-Content premium-note-popup"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="Value-Popup-Header premium-popup-header">
                <h4 className="Name">{popup.label}</h4>
                <button
                  className="Close-Icon"
                  onClick={() => setPopup({ ...popup, open: false })}
                >
                  ✕
                </button>
              </div>

              {popup.isTextEditor ? (
                <div className="Value-Popup-Body premium-popup-body">
                  <textarea
                    className="Premium-Text-Area"
                    value={popup.value || ""}
                    onChange={(e) =>
                      setPopup((prev) => ({ ...prev, value: e.target.value }))
                    }
                    rows={8}
                  />
                  <div className="Popup-Actions">
                    <button
                      type="button"
                      className="Premium-Secondary-Btn"
                      onClick={() => setPopup({ ...popup, open: false })}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="Premium-Primary-Btn"
                      onClick={() => {
                        setData((prev) => ({
                          ...prev,
                          [popup.fieldName]: popup.value || "",
                        }));
                        setPopup({ ...popup, open: false });
                      }}
                    >
                      Save
                    </button>
                  </div>
                </div>
              ) : (
                <p className="Popup-Value">{popup.value}</p>
              )}
            </div>
          </div>
        )}

        {filePreview.open && (
          <BasePopup
            open={filePreview.open}
            title={`File Preview - ${filePreview.name}`}
            showSearch={false}
            onClose={() =>
              setFilePreview({ open: false, name: "", src: "", type: "" })
            }
            customBody={
              <div
                style={{
                  minHeight: "220px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "16px",
                }}
              >
                {filePreview.type.startsWith("image/") ? (
                  <img
                    src={filePreview.src}
                    alt={filePreview.name}
                    style={{
                      maxWidth: "100%",
                      maxHeight: "60vh",
                      objectFit: "contain",
                    }}
                  />
                ) : filePreview.type === "application/pdf" ||
                  filePreview.type.startsWith("text/") ? (
                  <iframe
                    title={filePreview.name}
                    src={filePreview.src}
                    style={{
                      width: "100%",
                      height: "60vh",
                      border: "1px solid #dfe6ee",
                    }}
                  />
                ) : filePreview.type.startsWith("video/") ? (
                  <video
                    controls
                    src={filePreview.src}
                    style={{ maxWidth: "100%", maxHeight: "60vh" }}
                  />
                ) : filePreview.type.startsWith("audio/") ? (
                  <audio controls src={filePreview.src} />
                ) : (
                  <p>This file type cannot be previewed in the browser.</p>
                )}
              </div>
            }
            showFooter={false}
          />
        )}

        {selectPopup.open && (
          <BasePopup
            open={selectPopup.open}
            title="Select Record"
            columns={selectPopup.columns}
            rows={selectPopup.rows}
            searchValue={selectPopup.search}
            onSearchChange={(value) =>
              setSelectPopup((p) => ({
                ...p,
                search: value,
              }))
            }
            onClose={() => setSelectPopup({ ...selectPopup, open: false })}
            onRowClick={(row) => {
              const selectedRow = row;
              const selectedField = selectPopup.field;

              const fieldCfg = cfg.find((c) => c.ColHdName === selectedField);

              const pairedCfg = findPairedField(selectedField, cfg);

              setData((prev) => {
                const updated = { ...prev };

                updated[selectedField] = getValueFromRow(selectedRow, fieldCfg);

                if (pairedCfg) {
                  updated[pairedCfg.ColHdName] = getValueFromRow(
                    selectedRow,
                    pairedCfg,
                  );
                }

                if (selectedField === "BPCode" || selectedField === "BPName") {
                  const { GLCode, GLName } = getGLValuesFromBPRow(selectedRow);
                  updated.GLCode = GLCode;
                  updated.GLName = GLName;
                }
                if (selectedField === "TDSCode") {
                  updated.TDSCode = selectedRow.TDSCode || "";
                  updated.TDSRate = selectedRow.TDSRate || "";
                  updated.TDSAmt = selectedRow.TDSAmt || "";
                }

                return updated;
              });

              setSelectPopup((p) => ({ ...p, open: false }));
            }}
          />
        )}

        {gridPopup.open && (
          <BasePopup
            open={gridPopup.open}
            title="Grid Lookup"
            columns={gridPopup.columns}
            rows={gridPopup.rows}
            searchValue={gridPopup.search}
            onSearchChange={(value) =>
              setGridPopup((prev) => ({
                ...prev,
                search: value,
              }))
            }
            onClose={() =>
              setGridPopup((prev) => ({
                ...prev,
                open: false,
              }))
            }
            onRowClick={(row) => {
              const selectedGridKey =
                gridPopup.gridKey || activeGridTab || gridTabs[0] || "main";

              const rowIndex = gridPopup.rowIndex;

              updateGridRowsByKey(selectedGridKey, (prev) => {
                const updated = [...prev];

                if (
                  rowIndex === null ||
                  rowIndex === undefined ||
                  !updated[rowIndex]
                ) {
                  return prev;
                }

                const currentRow = { ...updated[rowIndex] };
                const currentGridCfg = gridConfigMap[selectedGridKey] || [];

                let updatedRow = mapPopupRowToGridRow(
                  currentRow,
                  row,
                  currentGridCfg,
                  gridPopup.field,
                );

                updatedRow = applyGridCalculations(updatedRow);
                updatedRow._rowCreated = true;
                updated[rowIndex] = updatedRow;

                return updated;
              });

              setGridPopup((prev) => ({
                ...prev,
                open: false,
              }));
            }}
          />
        )}

        {itemDetailsPopup.open && (
          <BasePopup
            open={itemDetailsPopup.open}
            title={itemDetailsPopup.title}
            showSearch={false}
            onClose={closeItemDetailsPopup}
            customBody={
              <textarea
                className="Premium-Text-Area"
                value={itemDetailsPopup.value}
                readOnly={isApprovedView}
                onChange={(event) =>
                  setItemDetailsPopup((prev) => ({
                    ...prev,
                    value: event.target.value,
                  }))
                }
                rows={8}
                autoFocus
              />
            }
            footerContent={
              <div
                className="Popup-Footer"
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "10px",
                }}
              >
                {!isApprovedView && (
                  <button
                    type="button"
                    className="purchase-order-footer-button purchase-order-save-button"
                    onClick={saveItemDetailsPopup}
                  >
                    <SaveIcon className="purchase-order-footer-button-icon" />
                    Save
                  </button>
                )}
                <button
                  type="button"
                  className="purchase-order-footer-button purchase-order-cancel-button"
                  onClick={closeItemDetailsPopup}
                >
                  <CloseIcon className="purchase-order-footer-button-icon" />
                  {isApprovedView ? "Close" : "Cancel"}
                </button>
              </div>
            }
            showFooter={true}
          />
        )}

        {linePopup.open && (
          <BasePopup
            open={linePopup.open}
            title={`Row Details - SL No ${linePopup.rowIndex + 1}`}
            showSearch={false}
            onClose={closeLinePopup}
            customBody={
              <div className="Popup-Table-Container">
                <table className="Popup-Table">
                  <tbody>
                    {gridCfg.map((c) => {
                      const field = c.Tbl_Col_Name;
                      const value = linePopup.row[field] ?? "";
                      const isReadOnly =
                        isApprovedView ||
                        (!isUpdateMode && c.ReadOnly === "TRUE");

                      return (
                        <tr key={field}>
                          <td style={{ fontWeight: 600, width: "35%" }}>
                            {c.ColHdText || field}
                          </td>
                          <td>
                            {isReadOnly ? (
                              <div className="read-only-field">{value}</div>
                            ) : (
                              <input
                                type="text"
                                className="Input-Field"
                                value={value}
                                onChange={(e) =>
                                  handleLinePopupFieldChange(
                                    field,
                                    e.target.value,
                                  )
                                }
                              />
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            }
            footerContent={
              <div
                className="popup-Footer"
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "10px",
                  marginBottom: "15px",
                }}
              >
                {!isUpdateMode && !isApprovedView && (
                  <button
                    className="purchase-order-footer-button purchase-order-save-button"
                    type="button"
                    onClick={saveLinePopup}
                  >
                    <SaveIcon className="purchase-order-footer-button-icon" />
                    Save
                  </button>
                )}
                <button
                  type="button"
                  className="purchase-order-footer-button purchase-order-cancel-button"
                  onClick={closeLinePopup}
                >
                  <CloseIcon className="purchase-order-footer-button-icon" />
                  {isUpdateMode || isApprovedView ? "Close" : "Cancel"}
                </button>
              </div>
            }
            showFooter={true}
          />
        )}
      </div>
    </div>
  );
}

export default FrmAPInvoice_MBC;
